export default {
    "scalars": [
        0,
        4,
        6,
        9,
        11,
        21,
        26,
        31,
        34,
        35,
        48,
        65,
        72,
        79,
        93,
        105,
        113,
        119,
        124,
        127,
        138,
        141,
        144,
        147,
        150,
        160,
        164,
        172,
        175,
        186,
        193,
        201,
        204,
        205,
        207,
        212,
        215,
        216,
        218,
        221,
        234,
        247,
        257,
        262,
        272,
        285,
        288,
        290,
        299,
        316,
        326,
        346,
        368,
        379,
        397,
        410,
        422,
        450,
        451,
        452,
        469,
        474,
        480,
        485,
        487,
        489,
        491,
        499,
        502,
        504
    ],
    "types": {
        "Boolean": {},
        "Boolean_comparison_exp": {
            "_eq": [
                0
            ],
            "_gt": [
                0
            ],
            "_gte": [
                0
            ],
            "_in": [
                0
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                0
            ],
            "_lte": [
                0
            ],
            "_neq": [
                0
            ],
            "_nin": [
                0
            ],
            "__typename": [
                9
            ]
        },
        "DriverUpdateDestinationAddress": {
            "data": [
                150
            ],
            "error": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "FinishScheduledRouteOutput": {
            "data": [
                150
            ],
            "error": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "Float": {},
        "GeneralOutput": {
            "data": [
                150
            ],
            "error": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "Int": {},
        "Int_comparison_exp": {
            "_eq": [
                6
            ],
            "_gt": [
                6
            ],
            "_gte": [
                6
            ],
            "_in": [
                6
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                6
            ],
            "_lte": [
                6
            ],
            "_neq": [
                6
            ],
            "_nin": [
                6
            ],
            "__typename": [
                9
            ]
        },
        "SampleOutput": {
            "data": [
                9
            ],
            "error": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "String": {},
        "String_comparison_exp": {
            "_eq": [
                9
            ],
            "_gt": [
                9
            ],
            "_gte": [
                9
            ],
            "_ilike": [
                9
            ],
            "_in": [
                9
            ],
            "_iregex": [
                9
            ],
            "_is_null": [
                0
            ],
            "_like": [
                9
            ],
            "_lt": [
                9
            ],
            "_lte": [
                9
            ],
            "_neq": [
                9
            ],
            "_nilike": [
                9
            ],
            "_nin": [
                9
            ],
            "_niregex": [
                9
            ],
            "_nlike": [
                9
            ],
            "_nregex": [
                9
            ],
            "_nsimilar": [
                9
            ],
            "_regex": [
                9
            ],
            "_similar": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "address_verification_status": {},
        "address_verification_status_comparison_exp": {
            "_eq": [
                11
            ],
            "_gt": [
                11
            ],
            "_gte": [
                11
            ],
            "_in": [
                11
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                11
            ],
            "_lte": [
                11
            ],
            "_neq": [
                11
            ],
            "_nin": [
                11
            ],
            "__typename": [
                9
            ]
        },
        "addresses": {
            "Buyer": [
                28
            ],
            "CityData": [
                471
            ],
            "Route_step": [
                401,
                {
                    "distinct_on": [
                        410,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        408,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        404
                    ]
                }
            ],
            "Seller": [
                282
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Undefined_buyer": [
                493
            ],
            "buyer_id": [
                504
            ],
            "city": [
                469
            ],
            "description": [
                9
            ],
            "id": [
                504
            ],
            "location": [
                147
            ],
            "name": [
                9
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "verification_status": [
                11
            ],
            "__typename": [
                9
            ]
        },
        "addresses_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                16
            ],
            "min": [
                17
            ],
            "__typename": [
                9
            ]
        },
        "addresses_bool_exp": {
            "Buyer": [
                29
            ],
            "CityData": [
                472
            ],
            "Route_step": [
                404
            ],
            "Seller": [
                283
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "Undefined_buyer": [
                495
            ],
            "_and": [
                15
            ],
            "_not": [
                15
            ],
            "_or": [
                15
            ],
            "buyer_id": [
                506
            ],
            "city": [
                470
            ],
            "description": [
                10
            ],
            "id": [
                506
            ],
            "location": [
                149
            ],
            "name": [
                10
            ],
            "seller_id": [
                506
            ],
            "undefined_buyer_id": [
                506
            ],
            "verification_status": [
                12
            ],
            "__typename": [
                9
            ]
        },
        "addresses_max_order_by": {
            "buyer_id": [
                215
            ],
            "city": [
                215
            ],
            "description": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "verification_status": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "addresses_min_order_by": {
            "buyer_id": [
                215
            ],
            "city": [
                215
            ],
            "description": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "verification_status": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "addresses_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                13
            ],
            "__typename": [
                9
            ]
        },
        "addresses_order_by": {
            "Buyer": [
                30
            ],
            "CityData": [
                473
            ],
            "Route_step_aggregate": [
                402
            ],
            "Seller": [
                284
            ],
            "Shipments_aggregate": [
                335
            ],
            "Undefined_buyer": [
                498
            ],
            "buyer_id": [
                215
            ],
            "city": [
                215
            ],
            "description": [
                215
            ],
            "id": [
                215
            ],
            "location": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "verification_status": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "addresses_pk_columns_input": {
            "id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "addresses_select_column": {},
        "addresses_set_input": {
            "description": [
                9
            ],
            "location": [
                147
            ],
            "verification_status": [
                11
            ],
            "__typename": [
                9
            ]
        },
        "addresses_stream_cursor_input": {
            "initial_value": [
                24
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "addresses_stream_cursor_value_input": {
            "buyer_id": [
                504
            ],
            "city": [
                469
            ],
            "description": [
                9
            ],
            "id": [
                504
            ],
            "location": [
                147
            ],
            "name": [
                9
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "verification_status": [
                11
            ],
            "__typename": [
                9
            ]
        },
        "addresses_updates": {
            "_set": [
                22
            ],
            "where": [
                15
            ],
            "__typename": [
                9
            ]
        },
        "bigint": {},
        "bigint_comparison_exp": {
            "_eq": [
                26
            ],
            "_gt": [
                26
            ],
            "_gte": [
                26
            ],
            "_in": [
                26
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                26
            ],
            "_lte": [
                26
            ],
            "_neq": [
                26
            ],
            "_nin": [
                26
            ],
            "__typename": [
                9
            ]
        },
        "buyers": {
            "Addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "buyers_bool_exp": {
            "Addresses": [
                15
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "_and": [
                29
            ],
            "_not": [
                29
            ],
            "_or": [
                29
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                506
            ],
            "image_id": [
                506
            ],
            "name": [
                10
            ],
            "phone_number": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "buyers_order_by": {
            "Addresses_aggregate": [
                14
            ],
            "Shipments_aggregate": [
                335
            ],
            "has_whatsapp": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "name": [
                215
            ],
            "phone_number": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "buyers_select_column": {},
        "buyers_stream_cursor_input": {
            "initial_value": [
                33
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "buyers_stream_cursor_value_input": {
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "cursor_ordering": {},
        "dimensions_cm_scalar": {},
        "dimensions_cm_scalar_comparison_exp": {
            "_eq": [
                35
            ],
            "_gt": [
                35
            ],
            "_gte": [
                35
            ],
            "_in": [
                35
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                35
            ],
            "_lte": [
                35
            ],
            "_neq": [
                35
            ],
            "_nin": [
                35
            ],
            "__typename": [
                9
            ]
        },
        "drivers": {
            "Assigned_shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Assigned_shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Locations": [
                61,
                {
                    "distinct_on": [
                        72,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        71,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        64
                    ]
                }
            ],
            "computed_balance": [
                207
            ],
            "computed_monthly_earnings": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "duty_time_windows_utc": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "end_location": [
                147
            ],
            "force_sync": [
                0
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_active": [
                0
            ],
            "location": [
                147
            ],
            "mobile_device_token": [
                9
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "start_location": [
                147
            ],
            "web_device_token": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "drivers_append_input": {
            "duty_time_windows_utc": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "drivers_bool_exp": {
            "Assigned_shipments": [
                338
            ],
            "Assigned_shipments_aggregate": [
                330
            ],
            "Locations": [
                64
            ],
            "_and": [
                39
            ],
            "_not": [
                39
            ],
            "_or": [
                39
            ],
            "computed_balance": [
                208
            ],
            "computed_monthly_earnings": [
                208
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "duty_time_windows_utc": [
                152
            ],
            "end_location": [
                149
            ],
            "force_sync": [
                1
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                506
            ],
            "image_id": [
                506
            ],
            "is_active": [
                1
            ],
            "location": [
                149
            ],
            "mobile_device_token": [
                10
            ],
            "name": [
                10
            ],
            "phone_number": [
                10
            ],
            "start_location": [
                149
            ],
            "web_device_token": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in": {
            "Driver": [
                37
            ],
            "Issued_by": [
                209
            ],
            "Received_by": [
                209
            ],
            "Route": [
                389
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_amount": [
                207
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "received_by": [
                504
            ],
            "route_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_aggregate": {
            "aggregate": [
                42
            ],
            "nodes": [
                40
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_aggregate_fields": {
            "avg": [
                43
            ],
            "count": [
                6,
                {
                    "columns": [
                        48,
                        "[drivers_collection_invoices_in_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                45
            ],
            "min": [
                46
            ],
            "stddev": [
                49
            ],
            "stddev_pop": [
                50
            ],
            "stddev_samp": [
                51
            ],
            "sum": [
                54
            ],
            "var_pop": [
                55
            ],
            "var_samp": [
                56
            ],
            "variance": [
                57
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_avg_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_bool_exp": {
            "Driver": [
                39
            ],
            "Issued_by": [
                210
            ],
            "Received_by": [
                210
            ],
            "Route": [
                393
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "_and": [
                44
            ],
            "_not": [
                44
            ],
            "_or": [
                44
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "invoice_amount": [
                208
            ],
            "invoice_number": [
                10
            ],
            "issued_by": [
                506
            ],
            "payment_timestamp": [
                490
            ],
            "received_by": [
                506
            ],
            "route_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_max_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_amount": [
                207
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "received_by": [
                504
            ],
            "route_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_min_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_amount": [
                207
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "received_by": [
                504
            ],
            "route_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_order_by": {
            "Driver": [
                84
            ],
            "Issued_by": [
                211
            ],
            "Received_by": [
                211
            ],
            "Route": [
                396
            ],
            "Shipments_aggregate": [
                335
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "invoice_amount": [
                215
            ],
            "invoice_number": [
                215
            ],
            "issued_by": [
                215
            ],
            "payment_timestamp": [
                215
            ],
            "received_by": [
                215
            ],
            "route_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_select_column": {},
        "drivers_collection_invoices_in_stddev_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_stddev_pop_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_stddev_samp_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_stream_cursor_input": {
            "initial_value": [
                53
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_stream_cursor_value_input": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_amount": [
                207
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "received_by": [
                504
            ],
            "route_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_sum_fields": {
            "invoice_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_var_pop_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_var_samp_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_collection_invoices_in_variance_fields": {
            "invoice_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_delete_at_path_input": {
            "duty_time_windows_utc": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "drivers_delete_elem_input": {
            "duty_time_windows_utc": [
                6
            ],
            "__typename": [
                9
            ]
        },
        "drivers_delete_key_input": {
            "duty_time_windows_utc": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations": {
            "Driver": [
                37
            ],
            "Shipments_route": [
                389
            ],
            "altitude": [
                127
            ],
            "altitude_accuracy": [
                127
            ],
            "bearing_string": [
                9
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "latitude": [
                207
            ],
            "location": [
                147
            ],
            "location_accuracy_radius": [
                127
            ],
            "location_recorded_time_unix": [
                26
            ],
            "longitude": [
                207
            ],
            "simulated": [
                0
            ],
            "speed": [
                127
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_aggregate_order_by": {
            "avg": [
                63
            ],
            "count": [
                215
            ],
            "max": [
                67
            ],
            "min": [
                68
            ],
            "stddev": [
                73
            ],
            "stddev_pop": [
                74
            ],
            "stddev_samp": [
                75
            ],
            "sum": [
                78
            ],
            "var_pop": [
                80
            ],
            "var_samp": [
                81
            ],
            "variance": [
                82
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_avg_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_bool_exp": {
            "Driver": [
                39
            ],
            "Shipments_route": [
                393
            ],
            "_and": [
                64
            ],
            "_not": [
                64
            ],
            "_or": [
                64
            ],
            "altitude": [
                128
            ],
            "altitude_accuracy": [
                128
            ],
            "bearing_string": [
                10
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "latitude": [
                208
            ],
            "location": [
                149
            ],
            "location_accuracy_radius": [
                128
            ],
            "location_recorded_time_unix": [
                27
            ],
            "longitude": [
                208
            ],
            "simulated": [
                1
            ],
            "speed": [
                128
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_constraint": {},
        "drivers_locations_insert_input": {
            "altitude": [
                127
            ],
            "altitude_accuracy": [
                127
            ],
            "bearing_string": [
                9
            ],
            "driver_id": [
                504
            ],
            "latitude": [
                207
            ],
            "location": [
                147
            ],
            "location_accuracy_radius": [
                127
            ],
            "location_recorded_time_unix": [
                26
            ],
            "longitude": [
                207
            ],
            "route_id": [
                504
            ],
            "simulated": [
                0
            ],
            "speed": [
                127
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_max_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "bearing_string": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_min_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "bearing_string": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                61
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_on_conflict": {
            "constraint": [
                65
            ],
            "update_columns": [
                79
            ],
            "where": [
                64
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_order_by": {
            "Driver": [
                84
            ],
            "Shipments_route": [
                396
            ],
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "bearing_string": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "latitude": [
                215
            ],
            "location": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "simulated": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_select_column": {},
        "drivers_locations_stddev_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_stddev_pop_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_stddev_samp_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_stream_cursor_input": {
            "initial_value": [
                77
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_stream_cursor_value_input": {
            "altitude": [
                127
            ],
            "altitude_accuracy": [
                127
            ],
            "bearing_string": [
                9
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "latitude": [
                207
            ],
            "location": [
                147
            ],
            "location_accuracy_radius": [
                127
            ],
            "location_recorded_time_unix": [
                26
            ],
            "longitude": [
                207
            ],
            "simulated": [
                0
            ],
            "speed": [
                127
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_sum_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_update_column": {},
        "drivers_locations_var_pop_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_var_samp_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_locations_variance_order_by": {
            "altitude": [
                215
            ],
            "altitude_accuracy": [
                215
            ],
            "latitude": [
                215
            ],
            "location_accuracy_radius": [
                215
            ],
            "location_recorded_time_unix": [
                215
            ],
            "longitude": [
                215
            ],
            "speed": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                37
            ],
            "__typename": [
                9
            ]
        },
        "drivers_order_by": {
            "Assigned_shipments_aggregate": [
                335
            ],
            "Locations_aggregate": [
                62
            ],
            "computed_balance": [
                215
            ],
            "computed_monthly_earnings": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "duty_time_windows_utc": [
                215
            ],
            "end_location": [
                215
            ],
            "force_sync": [
                215
            ],
            "has_whatsapp": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "is_active": [
                215
            ],
            "location": [
                215
            ],
            "mobile_device_token": [
                215
            ],
            "name": [
                215
            ],
            "phone_number": [
                215
            ],
            "start_location": [
                215
            ],
            "web_device_token": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out": {
            "Driver": [
                37
            ],
            "Issued_by": [
                209
            ],
            "Paid_by": [
                209
            ],
            "Route": [
                389
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "paid_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "payout_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_aggregate": {
            "aggregate": [
                87
            ],
            "nodes": [
                85
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_aggregate_fields": {
            "avg": [
                88
            ],
            "count": [
                6,
                {
                    "columns": [
                        93,
                        "[drivers_payouts_receipts_out_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                90
            ],
            "min": [
                91
            ],
            "stddev": [
                94
            ],
            "stddev_pop": [
                95
            ],
            "stddev_samp": [
                96
            ],
            "sum": [
                99
            ],
            "var_pop": [
                100
            ],
            "var_samp": [
                101
            ],
            "variance": [
                102
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_avg_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_bool_exp": {
            "Driver": [
                39
            ],
            "Issued_by": [
                210
            ],
            "Paid_by": [
                210
            ],
            "Route": [
                393
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "_and": [
                89
            ],
            "_not": [
                89
            ],
            "_or": [
                89
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "invoice_number": [
                10
            ],
            "issued_by": [
                506
            ],
            "paid_by": [
                506
            ],
            "payment_timestamp": [
                490
            ],
            "payout_amount": [
                208
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_max_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "paid_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "payout_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_min_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "paid_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "payout_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_order_by": {
            "Driver": [
                84
            ],
            "Issued_by": [
                211
            ],
            "Paid_by": [
                211
            ],
            "Route": [
                396
            ],
            "Shipments_aggregate": [
                335
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "invoice_number": [
                215
            ],
            "issued_by": [
                215
            ],
            "paid_by": [
                215
            ],
            "payment_timestamp": [
                215
            ],
            "payout_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_select_column": {},
        "drivers_payouts_receipts_out_stddev_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_stddev_pop_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_stddev_samp_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_stream_cursor_input": {
            "initial_value": [
                98
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_stream_cursor_value_input": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "invoice_number": [
                9
            ],
            "issued_by": [
                504
            ],
            "paid_by": [
                504
            ],
            "payment_timestamp": [
                489
            ],
            "payout_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_sum_fields": {
            "payout_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_var_pop_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_var_samp_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_payouts_receipts_out_variance_fields": {
            "payout_amount": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "drivers_pk_columns_input": {
            "id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_prepend_input": {
            "duty_time_windows_utc": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "drivers_select_column": {},
        "drivers_set_input": {
            "duty_time_windows_utc": [
                150
            ],
            "end_location": [
                147
            ],
            "force_sync": [
                0
            ],
            "image_id": [
                504
            ],
            "is_active": [
                0
            ],
            "mobile_device_token": [
                9
            ],
            "start_location": [
                147
            ],
            "web_device_token": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills": {
            "Driver": [
                37
            ],
            "Skill": [
                477
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "skill_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                110
            ],
            "min": [
                111
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_bool_exp": {
            "Driver": [
                39
            ],
            "Skill": [
                478
            ],
            "_and": [
                109
            ],
            "_not": [
                109
            ],
            "_or": [
                109
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "skill_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_max_order_by": {
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "skill_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_min_order_by": {
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "skill_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_order_by": {
            "Driver": [
                84
            ],
            "Skill": [
                479
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "skill_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_select_column": {},
        "drivers_skills_stream_cursor_input": {
            "initial_value": [
                115
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "drivers_skills_stream_cursor_value_input": {
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "skill_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "drivers_stream_cursor_input": {
            "initial_value": [
                117
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "drivers_stream_cursor_value_input": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "duty_time_windows_utc": [
                150
            ],
            "end_location": [
                147
            ],
            "force_sync": [
                0
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_active": [
                0
            ],
            "mobile_device_token": [
                9
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "start_location": [
                147
            ],
            "web_device_token": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "drivers_updates": {
            "_append": [
                38
            ],
            "_delete_at_path": [
                58
            ],
            "_delete_elem": [
                59
            ],
            "_delete_key": [
                60
            ],
            "_prepend": [
                104
            ],
            "_set": [
                106
            ],
            "where": [
                39
            ],
            "__typename": [
                9
            ]
        },
        "env_variable_type": {},
        "env_variable_type_comparison_exp": {
            "_eq": [
                119
            ],
            "_gt": [
                119
            ],
            "_gte": [
                119
            ],
            "_in": [
                119
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                119
            ],
            "_lte": [
                119
            ],
            "_neq": [
                119
            ],
            "_nin": [
                119
            ],
            "__typename": [
                9
            ]
        },
        "env_variables": {
            "id": [
                504
            ],
            "key": [
                9
            ],
            "value": [
                9
            ],
            "value_type": [
                119
            ],
            "__typename": [
                9
            ]
        },
        "env_variables_bool_exp": {
            "_and": [
                122
            ],
            "_not": [
                122
            ],
            "_or": [
                122
            ],
            "id": [
                506
            ],
            "key": [
                10
            ],
            "value": [
                10
            ],
            "value_type": [
                120
            ],
            "__typename": [
                9
            ]
        },
        "env_variables_order_by": {
            "id": [
                215
            ],
            "key": [
                215
            ],
            "value": [
                215
            ],
            "value_type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "env_variables_select_column": {},
        "env_variables_stream_cursor_input": {
            "initial_value": [
                126
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "env_variables_stream_cursor_value_input": {
            "id": [
                504
            ],
            "key": [
                9
            ],
            "value": [
                9
            ],
            "value_type": [
                119
            ],
            "__typename": [
                9
            ]
        },
        "float8": {},
        "float8_comparison_exp": {
            "_eq": [
                127
            ],
            "_gt": [
                127
            ],
            "_gte": [
                127
            ],
            "_in": [
                127
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                127
            ],
            "_lte": [
                127
            ],
            "_neq": [
                127
            ],
            "_nin": [
                127
            ],
            "__typename": [
                9
            ]
        },
        "food_categories": {
            "Categories": [
                132,
                {
                    "distinct_on": [
                        138,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        137,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        134
                    ]
                }
            ],
            "id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_bool_exp": {
            "Categories": [
                134
            ],
            "_and": [
                130
            ],
            "_not": [
                130
            ],
            "_or": [
                130
            ],
            "id": [
                506
            ],
            "name": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_order_by": {
            "Categories_aggregate": [
                133
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products": {
            "Category": [
                129
            ],
            "Product": [
                223
            ],
            "food_categories_id": [
                504
            ],
            "id": [
                504
            ],
            "products_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                135
            ],
            "min": [
                136
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_bool_exp": {
            "Category": [
                130
            ],
            "Product": [
                226
            ],
            "_and": [
                134
            ],
            "_not": [
                134
            ],
            "_or": [
                134
            ],
            "food_categories_id": [
                506
            ],
            "id": [
                506
            ],
            "products_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_max_order_by": {
            "food_categories_id": [
                215
            ],
            "id": [
                215
            ],
            "products_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_min_order_by": {
            "food_categories_id": [
                215
            ],
            "id": [
                215
            ],
            "products_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_order_by": {
            "Category": [
                131
            ],
            "Product": [
                246
            ],
            "food_categories_id": [
                215
            ],
            "id": [
                215
            ],
            "products_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_select_column": {},
        "food_categories_products_stream_cursor_input": {
            "initial_value": [
                140
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_products_stream_cursor_value_input": {
            "food_categories_id": [
                504
            ],
            "id": [
                504
            ],
            "products_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_select_column": {},
        "food_categories_stream_cursor_input": {
            "initial_value": [
                143
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "food_categories_stream_cursor_value_input": {
            "id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "geography": {},
        "geography_cast_exp": {
            "geometry": [
                149
            ],
            "__typename": [
                9
            ]
        },
        "geography_comparison_exp": {
            "_cast": [
                145
            ],
            "_eq": [
                144
            ],
            "_gt": [
                144
            ],
            "_gte": [
                144
            ],
            "_in": [
                144
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                144
            ],
            "_lte": [
                144
            ],
            "_neq": [
                144
            ],
            "_nin": [
                144
            ],
            "_st_d_within": [
                483
            ],
            "_st_intersects": [
                144
            ],
            "__typename": [
                9
            ]
        },
        "geometry": {},
        "geometry_cast_exp": {
            "geography": [
                146
            ],
            "__typename": [
                9
            ]
        },
        "geometry_comparison_exp": {
            "_cast": [
                148
            ],
            "_eq": [
                147
            ],
            "_gt": [
                147
            ],
            "_gte": [
                147
            ],
            "_in": [
                147
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                147
            ],
            "_lte": [
                147
            ],
            "_neq": [
                147
            ],
            "_nin": [
                147
            ],
            "_st_3d_d_within": [
                484
            ],
            "_st_3d_intersects": [
                147
            ],
            "_st_contains": [
                147
            ],
            "_st_crosses": [
                147
            ],
            "_st_d_within": [
                484
            ],
            "_st_equals": [
                147
            ],
            "_st_intersects": [
                147
            ],
            "_st_overlaps": [
                147
            ],
            "_st_touches": [
                147
            ],
            "_st_within": [
                147
            ],
            "__typename": [
                9
            ]
        },
        "jsonb": {},
        "jsonb_cast_exp": {
            "String": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "jsonb_comparison_exp": {
            "_cast": [
                151
            ],
            "_contained_in": [
                150
            ],
            "_contains": [
                150
            ],
            "_eq": [
                150
            ],
            "_gt": [
                150
            ],
            "_gte": [
                150
            ],
            "_has_key": [
                9
            ],
            "_has_keys_all": [
                9
            ],
            "_has_keys_any": [
                9
            ],
            "_in": [
                150
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                150
            ],
            "_lte": [
                150
            ],
            "_neq": [
                150
            ],
            "_nin": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "messages": {
            "From": [
                161
            ],
            "Shipment": [
                328
            ],
            "To": [
                190
            ],
            "attachment": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "location_stamp": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "read_timestamp": [
                489
            ],
            "shipment_id": [
                504
            ],
            "text": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "messages_aggregate": {
            "aggregate": [
                157
            ],
            "nodes": [
                153
            ],
            "__typename": [
                9
            ]
        },
        "messages_aggregate_bool_exp": {
            "count": [
                156
            ],
            "__typename": [
                9
            ]
        },
        "messages_aggregate_bool_exp_count": {
            "arguments": [
                186
            ],
            "distinct": [
                0
            ],
            "filter": [
                159
            ],
            "predicate": [
                7
            ],
            "__typename": [
                9
            ]
        },
        "messages_aggregate_fields": {
            "count": [
                6,
                {
                    "columns": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                177
            ],
            "min": [
                179
            ],
            "__typename": [
                9
            ]
        },
        "messages_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                178
            ],
            "min": [
                180
            ],
            "__typename": [
                9
            ]
        },
        "messages_bool_exp": {
            "From": [
                163
            ],
            "Shipment": [
                338
            ],
            "To": [
                192
            ],
            "_and": [
                159
            ],
            "_not": [
                159
            ],
            "_or": [
                159
            ],
            "attachment": [
                152
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "id": [
                506
            ],
            "location_stamp": [
                152
            ],
            "read_timestamp": [
                490
            ],
            "shipment_id": [
                506
            ],
            "text": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "messages_constraint": {},
        "messages_from": {
            "Buyer": [
                28
            ],
            "Driver": [
                37
            ],
            "Message": [
                153
            ],
            "Operator": [
                209
            ],
            "Seller": [
                282
            ],
            "Undefined_buyer": [
                493
            ],
            "buyer_id": [
                504
            ],
            "date_created": [
                487
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "message_id": [
                504
            ],
            "operator_id": [
                504
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                166
            ],
            "min": [
                167
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_bool_exp": {
            "Buyer": [
                29
            ],
            "Driver": [
                39
            ],
            "Message": [
                159
            ],
            "Operator": [
                210
            ],
            "Seller": [
                283
            ],
            "Undefined_buyer": [
                495
            ],
            "_and": [
                163
            ],
            "_not": [
                163
            ],
            "_or": [
                163
            ],
            "buyer_id": [
                506
            ],
            "date_created": [
                488
            ],
            "date_updated": [
                490
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "message_id": [
                506
            ],
            "operator_id": [
                506
            ],
            "seller_id": [
                506
            ],
            "undefined_buyer_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_constraint": {},
        "messages_from_insert_input": {
            "Message": [
                182
            ],
            "driver_id": [
                504
            ],
            "message_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_max_order_by": {
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_min_order_by": {
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                161
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_obj_rel_insert_input": {
            "data": [
                165
            ],
            "on_conflict": [
                170
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_on_conflict": {
            "constraint": [
                164
            ],
            "update_columns": [
                175
            ],
            "where": [
                163
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_order_by": {
            "Buyer": [
                30
            ],
            "Driver": [
                84
            ],
            "Message": [
                184
            ],
            "Operator": [
                211
            ],
            "Seller": [
                284
            ],
            "Undefined_buyer": [
                498
            ],
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_select_column": {},
        "messages_from_stream_cursor_input": {
            "initial_value": [
                174
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_stream_cursor_value_input": {
            "buyer_id": [
                504
            ],
            "date_created": [
                487
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "message_id": [
                504
            ],
            "operator_id": [
                504
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_from_update_column": {},
        "messages_insert_input": {
            "From": [
                169
            ],
            "To": [
                198
            ],
            "attachment": [
                150
            ],
            "location_stamp": [
                150
            ],
            "shipment_id": [
                504
            ],
            "text": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "messages_max_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "read_timestamp": [
                489
            ],
            "shipment_id": [
                504
            ],
            "text": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "messages_max_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "read_timestamp": [
                215
            ],
            "shipment_id": [
                215
            ],
            "text": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_min_fields": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "read_timestamp": [
                489
            ],
            "shipment_id": [
                504
            ],
            "text": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "messages_min_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "read_timestamp": [
                215
            ],
            "shipment_id": [
                215
            ],
            "text": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                153
            ],
            "__typename": [
                9
            ]
        },
        "messages_obj_rel_insert_input": {
            "data": [
                176
            ],
            "on_conflict": [
                183
            ],
            "__typename": [
                9
            ]
        },
        "messages_on_conflict": {
            "constraint": [
                160
            ],
            "update_columns": [
                205
            ],
            "where": [
                159
            ],
            "__typename": [
                9
            ]
        },
        "messages_order_by": {
            "From": [
                171
            ],
            "Shipment": [
                371
            ],
            "To": [
                200
            ],
            "attachment": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "location_stamp": [
                215
            ],
            "read_timestamp": [
                215
            ],
            "shipment_id": [
                215
            ],
            "text": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_pk_columns_input": {
            "id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_select_column": {},
        "messages_set_input": {
            "read_timestamp": [
                489
            ],
            "__typename": [
                9
            ]
        },
        "messages_stream_cursor_input": {
            "initial_value": [
                189
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "messages_stream_cursor_value_input": {
            "attachment": [
                150
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "location_stamp": [
                150
            ],
            "read_timestamp": [
                489
            ],
            "shipment_id": [
                504
            ],
            "text": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "messages_to": {
            "Buyer": [
                28
            ],
            "Driver": [
                37
            ],
            "Message": [
                153
            ],
            "Operator": [
                209
            ],
            "Seller": [
                282
            ],
            "Undefined_buyer": [
                493
            ],
            "buyer_id": [
                504
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "message_id": [
                504
            ],
            "operator_id": [
                504
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                195
            ],
            "min": [
                196
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_bool_exp": {
            "Buyer": [
                29
            ],
            "Driver": [
                39
            ],
            "Message": [
                159
            ],
            "Operator": [
                210
            ],
            "Seller": [
                283
            ],
            "Undefined_buyer": [
                495
            ],
            "_and": [
                192
            ],
            "_not": [
                192
            ],
            "_or": [
                192
            ],
            "buyer_id": [
                506
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "driver_id": [
                506
            ],
            "id": [
                506
            ],
            "message_id": [
                506
            ],
            "operator_id": [
                506
            ],
            "seller_id": [
                506
            ],
            "undefined_buyer_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_constraint": {},
        "messages_to_insert_input": {
            "Message": [
                182
            ],
            "buyer_id": [
                504
            ],
            "message_id": [
                504
            ],
            "operator_id": [
                504
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_max_order_by": {
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_min_order_by": {
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                190
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_obj_rel_insert_input": {
            "data": [
                194
            ],
            "on_conflict": [
                199
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_on_conflict": {
            "constraint": [
                193
            ],
            "update_columns": [
                204
            ],
            "where": [
                192
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_order_by": {
            "Buyer": [
                30
            ],
            "Driver": [
                84
            ],
            "Message": [
                184
            ],
            "Operator": [
                211
            ],
            "Seller": [
                284
            ],
            "Undefined_buyer": [
                498
            ],
            "buyer_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "driver_id": [
                215
            ],
            "id": [
                215
            ],
            "message_id": [
                215
            ],
            "operator_id": [
                215
            ],
            "seller_id": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_select_column": {},
        "messages_to_stream_cursor_input": {
            "initial_value": [
                203
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_stream_cursor_value_input": {
            "buyer_id": [
                504
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "driver_id": [
                504
            ],
            "id": [
                504
            ],
            "message_id": [
                504
            ],
            "operator_id": [
                504
            ],
            "seller_id": [
                504
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "messages_to_update_column": {},
        "messages_update_column": {},
        "messages_updates": {
            "_set": [
                187
            ],
            "where": [
                159
            ],
            "__typename": [
                9
            ]
        },
        "numeric": {},
        "numeric_comparison_exp": {
            "_eq": [
                207
            ],
            "_gt": [
                207
            ],
            "_gte": [
                207
            ],
            "_in": [
                207
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                207
            ],
            "_lte": [
                207
            ],
            "_neq": [
                207
            ],
            "_nin": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "operators": {
            "Messages_incoming": [
                190,
                {
                    "distinct_on": [
                        201,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        200,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        192
                    ]
                }
            ],
            "Messages_outgoing": [
                161,
                {
                    "distinct_on": [
                        172,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        171,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        163
                    ]
                }
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "operators_bool_exp": {
            "Messages_incoming": [
                192
            ],
            "Messages_outgoing": [
                163
            ],
            "_and": [
                210
            ],
            "_not": [
                210
            ],
            "_or": [
                210
            ],
            "id": [
                506
            ],
            "image_id": [
                506
            ],
            "name": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "operators_order_by": {
            "Messages_incoming_aggregate": [
                191
            ],
            "Messages_outgoing_aggregate": [
                162
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "name": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "operators_select_column": {},
        "operators_stream_cursor_input": {
            "initial_value": [
                214
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "operators_stream_cursor_value_input": {
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "order_by": {},
        "payment_gateway": {},
        "payment_gateway_comparison_exp": {
            "_eq": [
                216
            ],
            "_gt": [
                216
            ],
            "_gte": [
                216
            ],
            "_in": [
                216
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                216
            ],
            "_lte": [
                216
            ],
            "_neq": [
                216
            ],
            "_nin": [
                216
            ],
            "__typename": [
                9
            ]
        },
        "payment_method": {},
        "payment_method_array_comparison_exp": {
            "_contained_in": [
                218
            ],
            "_contains": [
                218
            ],
            "_eq": [
                218
            ],
            "_gt": [
                218
            ],
            "_gte": [
                218
            ],
            "_in": [
                218
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                218
            ],
            "_lte": [
                218
            ],
            "_neq": [
                218
            ],
            "_nin": [
                218
            ],
            "__typename": [
                9
            ]
        },
        "payment_method_comparison_exp": {
            "_eq": [
                218
            ],
            "_gt": [
                218
            ],
            "_gte": [
                218
            ],
            "_in": [
                218
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                218
            ],
            "_lte": [
                218
            ],
            "_neq": [
                218
            ],
            "_nin": [
                218
            ],
            "__typename": [
                9
            ]
        },
        "payment_status": {},
        "payment_status_comparison_exp": {
            "_eq": [
                221
            ],
            "_gt": [
                221
            ],
            "_gte": [
                221
            ],
            "_in": [
                221
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                221
            ],
            "_lte": [
                221
            ],
            "_neq": [
                221
            ],
            "_nin": [
                221
            ],
            "__typename": [
                9
            ]
        },
        "products": {
            "Extras": [
                227,
                {
                    "distinct_on": [
                        234,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        233,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "Seller": [
                282
            ],
            "Shipments": [
                309,
                {
                    "distinct_on": [
                        316,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        315,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        312
                    ]
                }
            ],
            "Standard_size": [
                265
            ],
            "description": [
                9
            ],
            "dimensions_cm": [
                35
            ],
            "extra_images_ids": [
                504
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "is_retail": [
                0
            ],
            "min_quantity": [
                207
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "retail_price": [
                207
            ],
            "seller_id": [
                504
            ],
            "standard_size_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "products_aggregate_order_by": {
            "avg": [
                225
            ],
            "count": [
                215
            ],
            "max": [
                244
            ],
            "min": [
                245
            ],
            "stddev": [
                248
            ],
            "stddev_pop": [
                249
            ],
            "stddev_samp": [
                250
            ],
            "sum": [
                253
            ],
            "var_pop": [
                254
            ],
            "var_samp": [
                255
            ],
            "variance": [
                256
            ],
            "__typename": [
                9
            ]
        },
        "products_avg_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_bool_exp": {
            "Extras": [
                230
            ],
            "Seller": [
                283
            ],
            "Shipments": [
                312
            ],
            "Standard_size": [
                268
            ],
            "_and": [
                226
            ],
            "_not": [
                226
            ],
            "_or": [
                226
            ],
            "description": [
                10
            ],
            "dimensions_cm": [
                36
            ],
            "extra_images_ids": [
                505
            ],
            "id": [
                506
            ],
            "image_id": [
                506
            ],
            "is_available": [
                1
            ],
            "is_deleted": [
                1
            ],
            "is_retail": [
                1
            ],
            "min_quantity": [
                208
            ],
            "name": [
                10
            ],
            "price": [
                208
            ],
            "retail_price": [
                208
            ],
            "seller_id": [
                506
            ],
            "standard_size_id": [
                506
            ],
            "volume_cm3": [
                208
            ],
            "__typename": [
                9
            ]
        },
        "products_extras": {
            "Product": [
                223
            ],
            "Shipment_products": [
                292,
                {
                    "distinct_on": [
                        299,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        298,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        295
                    ]
                }
            ],
            "description": [
                9
            ],
            "id": [
                504
            ],
            "is_available": [
                0
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "product_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_aggregate_order_by": {
            "avg": [
                229
            ],
            "count": [
                215
            ],
            "max": [
                231
            ],
            "min": [
                232
            ],
            "stddev": [
                235
            ],
            "stddev_pop": [
                236
            ],
            "stddev_samp": [
                237
            ],
            "sum": [
                240
            ],
            "var_pop": [
                241
            ],
            "var_samp": [
                242
            ],
            "variance": [
                243
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_avg_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_bool_exp": {
            "Product": [
                226
            ],
            "Shipment_products": [
                295
            ],
            "_and": [
                230
            ],
            "_not": [
                230
            ],
            "_or": [
                230
            ],
            "description": [
                10
            ],
            "id": [
                506
            ],
            "is_available": [
                1
            ],
            "name": [
                10
            ],
            "price": [
                208
            ],
            "product_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_max_order_by": {
            "description": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "product_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_min_order_by": {
            "description": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "product_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_order_by": {
            "Product": [
                246
            ],
            "Shipment_products_aggregate": [
                293
            ],
            "description": [
                215
            ],
            "id": [
                215
            ],
            "is_available": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "product_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_select_column": {},
        "products_extras_stddev_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_stddev_pop_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_stddev_samp_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_stream_cursor_input": {
            "initial_value": [
                239
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_stream_cursor_value_input": {
            "description": [
                9
            ],
            "id": [
                504
            ],
            "is_available": [
                0
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "product_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_sum_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_var_pop_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_var_samp_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_extras_variance_order_by": {
            "price": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_max_order_by": {
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "extra_images_ids": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "min_quantity": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "seller_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_min_order_by": {
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "extra_images_ids": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "min_quantity": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "seller_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_order_by": {
            "Extras_aggregate": [
                228
            ],
            "Seller": [
                284
            ],
            "Shipments_aggregate": [
                310
            ],
            "Standard_size": [
                271
            ],
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "extra_images_ids": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "is_available": [
                215
            ],
            "is_deleted": [
                215
            ],
            "is_retail": [
                215
            ],
            "min_quantity": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "seller_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_select_column": {},
        "products_stddev_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_stddev_pop_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_stddev_samp_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_stream_cursor_input": {
            "initial_value": [
                252
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "products_stream_cursor_value_input": {
            "description": [
                9
            ],
            "dimensions_cm": [
                35
            ],
            "extra_images_ids": [
                504
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_available": [
                0
            ],
            "is_deleted": [
                0
            ],
            "is_retail": [
                0
            ],
            "min_quantity": [
                207
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "retail_price": [
                207
            ],
            "seller_id": [
                504
            ],
            "standard_size_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "products_sum_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_var_pop_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_var_samp_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "products_variance_order_by": {
            "min_quantity": [
                215
            ],
            "price": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "route_step_status": {},
        "route_step_status_comparison_exp": {
            "_eq": [
                257
            ],
            "_gt": [
                257
            ],
            "_gte": [
                257
            ],
            "_in": [
                257
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                257
            ],
            "_lte": [
                257
            ],
            "_neq": [
                257
            ],
            "_nin": [
                257
            ],
            "__typename": [
                9
            ]
        },
        "sales_channels": {
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Undefined_buyers": [
                493,
                {
                    "distinct_on": [
                        499,
                        "[undefined_buyers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        498,
                        "[undefined_buyers_order_by!]"
                    ],
                    "where": [
                        495
                    ]
                }
            ],
            "id": [
                504
            ],
            "name": [
                9
            ],
            "platform_type": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "sales_channels_bool_exp": {
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "Undefined_buyers": [
                495
            ],
            "_and": [
                260
            ],
            "_not": [
                260
            ],
            "_or": [
                260
            ],
            "id": [
                506
            ],
            "name": [
                10
            ],
            "platform_type": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "sales_channels_order_by": {
            "Shipments_aggregate": [
                335
            ],
            "Undefined_buyers_aggregate": [
                494
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "platform_type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "sales_channels_select_column": {},
        "sales_channels_stream_cursor_input": {
            "initial_value": [
                264
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "sales_channels_stream_cursor_value_input": {
            "id": [
                504
            ],
            "name": [
                9
            ],
            "platform_type": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes": {
            "Products": [
                223,
                {
                    "distinct_on": [
                        247,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        246,
                        "[products_order_by!]"
                    ],
                    "where": [
                        226
                    ]
                }
            ],
            "Seller": [
                282
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "height": [
                207
            ],
            "id": [
                504
            ],
            "length": [
                207
            ],
            "name": [
                9
            ],
            "seller_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "width": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_aggregate_order_by": {
            "avg": [
                267
            ],
            "count": [
                215
            ],
            "max": [
                269
            ],
            "min": [
                270
            ],
            "stddev": [
                273
            ],
            "stddev_pop": [
                274
            ],
            "stddev_samp": [
                275
            ],
            "sum": [
                278
            ],
            "var_pop": [
                279
            ],
            "var_samp": [
                280
            ],
            "variance": [
                281
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_avg_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_bool_exp": {
            "Products": [
                226
            ],
            "Seller": [
                283
            ],
            "_and": [
                268
            ],
            "_not": [
                268
            ],
            "_or": [
                268
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "height": [
                208
            ],
            "id": [
                506
            ],
            "length": [
                208
            ],
            "name": [
                10
            ],
            "seller_id": [
                506
            ],
            "volume_cm3": [
                208
            ],
            "width": [
                208
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_max_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "height": [
                215
            ],
            "id": [
                215
            ],
            "length": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_min_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "height": [
                215
            ],
            "id": [
                215
            ],
            "length": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_order_by": {
            "Products_aggregate": [
                224
            ],
            "Seller": [
                284
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "height": [
                215
            ],
            "id": [
                215
            ],
            "length": [
                215
            ],
            "name": [
                215
            ],
            "seller_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_select_column": {},
        "seller_products_standard_sizes_stddev_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_stddev_pop_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_stddev_samp_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_stream_cursor_input": {
            "initial_value": [
                277
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_stream_cursor_value_input": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "height": [
                207
            ],
            "id": [
                504
            ],
            "length": [
                207
            ],
            "name": [
                9
            ],
            "seller_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "width": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_sum_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_var_pop_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_var_samp_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "seller_products_standard_sizes_variance_order_by": {
            "height": [
                215
            ],
            "length": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "width": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "sellers": {
            "Addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "Products": [
                223,
                {
                    "distinct_on": [
                        247,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        246,
                        "[products_order_by!]"
                    ],
                    "where": [
                        226
                    ]
                }
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Standard_sizes": [
                265,
                {
                    "distinct_on": [
                        272,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        271,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        268
                    ]
                }
            ],
            "description": [
                9
            ],
            "extra_images_ids": [
                504
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_available": [
                0
            ],
            "name": [
                9
            ],
            "ops_has_whatsapp": [
                0
            ],
            "ops_phone_number": [
                9
            ],
            "pickup_time_windows_utc": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "public_has_whatsapp": [
                0
            ],
            "public_phone_number": [
                9
            ],
            "seller_number": [
                6
            ],
            "shipping_geofence": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "__typename": [
                9
            ]
        },
        "sellers_bool_exp": {
            "Addresses": [
                15
            ],
            "Products": [
                226
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "Standard_sizes": [
                268
            ],
            "_and": [
                283
            ],
            "_not": [
                283
            ],
            "_or": [
                283
            ],
            "description": [
                10
            ],
            "extra_images_ids": [
                505
            ],
            "id": [
                506
            ],
            "image_id": [
                506
            ],
            "is_available": [
                1
            ],
            "name": [
                10
            ],
            "ops_has_whatsapp": [
                1
            ],
            "ops_phone_number": [
                10
            ],
            "pickup_time_windows_utc": [
                152
            ],
            "public_has_whatsapp": [
                1
            ],
            "public_phone_number": [
                10
            ],
            "seller_number": [
                7
            ],
            "shipping_geofence": [
                152
            ],
            "__typename": [
                9
            ]
        },
        "sellers_order_by": {
            "Addresses_aggregate": [
                14
            ],
            "Products_aggregate": [
                224
            ],
            "Shipments_aggregate": [
                335
            ],
            "Standard_sizes_aggregate": [
                266
            ],
            "description": [
                215
            ],
            "extra_images_ids": [
                215
            ],
            "id": [
                215
            ],
            "image_id": [
                215
            ],
            "is_available": [
                215
            ],
            "name": [
                215
            ],
            "ops_has_whatsapp": [
                215
            ],
            "ops_phone_number": [
                215
            ],
            "pickup_time_windows_utc": [
                215
            ],
            "public_has_whatsapp": [
                215
            ],
            "public_phone_number": [
                215
            ],
            "seller_number": [
                215
            ],
            "shipping_geofence": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "sellers_select_column": {},
        "sellers_stream_cursor_input": {
            "initial_value": [
                287
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "sellers_stream_cursor_value_input": {
            "description": [
                9
            ],
            "extra_images_ids": [
                504
            ],
            "id": [
                504
            ],
            "image_id": [
                504
            ],
            "is_available": [
                0
            ],
            "name": [
                9
            ],
            "ops_has_whatsapp": [
                0
            ],
            "ops_phone_number": [
                9
            ],
            "pickup_time_windows_utc": [
                150
            ],
            "public_has_whatsapp": [
                0
            ],
            "public_phone_number": [
                9
            ],
            "seller_number": [
                6
            ],
            "shipping_geofence": [
                150
            ],
            "__typename": [
                9
            ]
        },
        "shipment_note": {},
        "shipment_note_comparison_exp": {
            "_eq": [
                288
            ],
            "_gt": [
                288
            ],
            "_gte": [
                288
            ],
            "_in": [
                288
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                288
            ],
            "_lte": [
                288
            ],
            "_neq": [
                288
            ],
            "_nin": [
                288
            ],
            "__typename": [
                9
            ]
        },
        "shipment_payment_status": {},
        "shipment_payment_status_comparison_exp": {
            "_eq": [
                290
            ],
            "_gt": [
                290
            ],
            "_gte": [
                290
            ],
            "_in": [
                290
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                290
            ],
            "_lte": [
                290
            ],
            "_neq": [
                290
            ],
            "_nin": [
                290
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras": {
            "Extra": [
                227
            ],
            "Shipment_item": [
                309
            ],
            "calculated_price": [
                207
            ],
            "id": [
                504
            ],
            "product_extra_id": [
                504
            ],
            "quantity": [
                207
            ],
            "shipment_product_item_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_aggregate_order_by": {
            "avg": [
                294
            ],
            "count": [
                215
            ],
            "max": [
                296
            ],
            "min": [
                297
            ],
            "stddev": [
                300
            ],
            "stddev_pop": [
                301
            ],
            "stddev_samp": [
                302
            ],
            "sum": [
                305
            ],
            "var_pop": [
                306
            ],
            "var_samp": [
                307
            ],
            "variance": [
                308
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_avg_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_bool_exp": {
            "Extra": [
                230
            ],
            "Shipment_item": [
                312
            ],
            "_and": [
                295
            ],
            "_not": [
                295
            ],
            "_or": [
                295
            ],
            "calculated_price": [
                208
            ],
            "id": [
                506
            ],
            "product_extra_id": [
                506
            ],
            "quantity": [
                208
            ],
            "shipment_product_item_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_max_order_by": {
            "calculated_price": [
                215
            ],
            "id": [
                215
            ],
            "product_extra_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_product_item_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_min_order_by": {
            "calculated_price": [
                215
            ],
            "id": [
                215
            ],
            "product_extra_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_product_item_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_order_by": {
            "Extra": [
                233
            ],
            "Shipment_item": [
                315
            ],
            "calculated_price": [
                215
            ],
            "id": [
                215
            ],
            "product_extra_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_product_item_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_select_column": {},
        "shipment_product_item_extras_stddev_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_stddev_pop_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_stddev_samp_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_stream_cursor_input": {
            "initial_value": [
                304
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_stream_cursor_value_input": {
            "calculated_price": [
                207
            ],
            "id": [
                504
            ],
            "product_extra_id": [
                504
            ],
            "quantity": [
                207
            ],
            "shipment_product_item_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_sum_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_var_pop_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_var_samp_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_product_item_extras_variance_order_by": {
            "calculated_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items": {
            "Product": [
                223
            ],
            "Product_extras": [
                292,
                {
                    "distinct_on": [
                        299,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        298,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        295
                    ]
                }
            ],
            "Shipment": [
                328
            ],
            "calculated_price": [
                207
            ],
            "calculated_seller_price": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "product_id": [
                504
            ],
            "quantity": [
                207
            ],
            "shipment_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_aggregate_order_by": {
            "avg": [
                311
            ],
            "count": [
                215
            ],
            "max": [
                313
            ],
            "min": [
                314
            ],
            "stddev": [
                317
            ],
            "stddev_pop": [
                318
            ],
            "stddev_samp": [
                319
            ],
            "sum": [
                322
            ],
            "var_pop": [
                323
            ],
            "var_samp": [
                324
            ],
            "variance": [
                325
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_avg_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_bool_exp": {
            "Product": [
                226
            ],
            "Product_extras": [
                295
            ],
            "Shipment": [
                338
            ],
            "_and": [
                312
            ],
            "_not": [
                312
            ],
            "_or": [
                312
            ],
            "calculated_price": [
                208
            ],
            "calculated_seller_price": [
                208
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "id": [
                506
            ],
            "product_id": [
                506
            ],
            "quantity": [
                208
            ],
            "shipment_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_max_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "product_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_min_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "product_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_order_by": {
            "Product": [
                246
            ],
            "Product_extras_aggregate": [
                293
            ],
            "Shipment": [
                371
            ],
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "product_id": [
                215
            ],
            "quantity": [
                215
            ],
            "shipment_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_select_column": {},
        "shipment_products_items_stddev_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_stddev_pop_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_stddev_samp_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_stream_cursor_input": {
            "initial_value": [
                321
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_stream_cursor_value_input": {
            "calculated_price": [
                207
            ],
            "calculated_seller_price": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "product_id": [
                504
            ],
            "quantity": [
                207
            ],
            "shipment_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_sum_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_var_pop_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_var_samp_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_products_items_variance_order_by": {
            "calculated_price": [
                215
            ],
            "calculated_seller_price": [
                215
            ],
            "quantity": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipment_status": {},
        "shipment_status_comparison_exp": {
            "_eq": [
                326
            ],
            "_gt": [
                326
            ],
            "_gte": [
                326
            ],
            "_in": [
                326
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                326
            ],
            "_lte": [
                326
            ],
            "_neq": [
                326
            ],
            "_nin": [
                326
            ],
            "__typename": [
                9
            ]
        },
        "shipments": {
            "Assigned_driver": [
                37
            ],
            "Boxes": [
                339,
                {
                    "distinct_on": [
                        346,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        345,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        342
                    ]
                }
            ],
            "Buyer": [
                28
            ],
            "Destination_address": [
                13
            ],
            "Messages": [
                153,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "Messages_aggregate": [
                154,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "Notes": [
                360,
                {
                    "distinct_on": [
                        368,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        367,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        362
                    ]
                }
            ],
            "Payments": [
                372,
                {
                    "distinct_on": [
                        379,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        378,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        375
                    ]
                }
            ],
            "Products": [
                309,
                {
                    "distinct_on": [
                        316,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        315,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        312
                    ]
                }
            ],
            "Routes_steps": [
                412,
                {
                    "distinct_on": [
                        422,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        420,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        415
                    ]
                }
            ],
            "Sales_channel": [
                259
            ],
            "Seller": [
                282
            ],
            "Shipments_route": [
                389
            ],
            "Undefined_buyer": [
                493
            ],
            "allowed_payment_methods": [
                218
            ],
            "amount_paid": [
                207
            ],
            "assigned_driver_id": [
                504
            ],
            "base_shipping_cost": [
                207
            ],
            "buyer_id": [
                504
            ],
            "cancellation_object": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "company_discount": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "delivered_timestamp": [
                489
            ],
            "destination_address_id": [
                504
            ],
            "driver_payout_receipt_out_id": [
                504
            ],
            "driver_route_invoice_in_id": [
                504
            ],
            "dynamic_shipping_cost": [
                207
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "external_reference_id": [
                9
            ],
            "id": [
                504
            ],
            "is_active": [
                0
            ],
            "is_company_free_shipping": [
                0
            ],
            "is_seller_free_shipping": [
                0
            ],
            "payment_status": [
                290
            ],
            "preferred_delivery_time_windows_utc": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "products_cost": [
                207
            ],
            "products_cost_seller": [
                207
            ],
            "products_paid_in_advance": [
                0
            ],
            "ready_time": [
                489
            ],
            "required_amount": [
                207
            ],
            "route_id": [
                504
            ],
            "sales_channel_id": [
                504
            ],
            "seller_discount": [
                207
            ],
            "seller_id": [
                504
            ],
            "shipment_number": [
                9
            ],
            "shipping_cost": [
                207
            ],
            "status": [
                326
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate": {
            "aggregate": [
                334
            ],
            "nodes": [
                328
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_bool_exp": {
            "bool_and": [
                331
            ],
            "bool_or": [
                332
            ],
            "count": [
                333
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_bool_exp_bool_and": {
            "arguments": [
                451
            ],
            "distinct": [
                0
            ],
            "filter": [
                338
            ],
            "predicate": [
                1
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_bool_exp_bool_or": {
            "arguments": [
                452
            ],
            "distinct": [
                0
            ],
            "filter": [
                338
            ],
            "predicate": [
                1
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_bool_exp_count": {
            "arguments": [
                450
            ],
            "distinct": [
                0
            ],
            "filter": [
                338
            ],
            "predicate": [
                7
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_fields": {
            "avg": [
                336
            ],
            "count": [
                6,
                {
                    "columns": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                356
            ],
            "min": [
                358
            ],
            "stddev": [
                453
            ],
            "stddev_pop": [
                455
            ],
            "stddev_samp": [
                457
            ],
            "sum": [
                461
            ],
            "var_pop": [
                463
            ],
            "var_samp": [
                465
            ],
            "variance": [
                467
            ],
            "__typename": [
                9
            ]
        },
        "shipments_aggregate_order_by": {
            "avg": [
                337
            ],
            "count": [
                215
            ],
            "max": [
                357
            ],
            "min": [
                359
            ],
            "stddev": [
                454
            ],
            "stddev_pop": [
                456
            ],
            "stddev_samp": [
                458
            ],
            "sum": [
                462
            ],
            "var_pop": [
                464
            ],
            "var_samp": [
                466
            ],
            "variance": [
                468
            ],
            "__typename": [
                9
            ]
        },
        "shipments_avg_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_avg_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_bool_exp": {
            "Assigned_driver": [
                39
            ],
            "Boxes": [
                342
            ],
            "Buyer": [
                29
            ],
            "Destination_address": [
                15
            ],
            "Messages": [
                159
            ],
            "Messages_aggregate": [
                155
            ],
            "Notes": [
                362
            ],
            "Payments": [
                375
            ],
            "Products": [
                312
            ],
            "Routes_steps": [
                415
            ],
            "Sales_channel": [
                260
            ],
            "Seller": [
                283
            ],
            "Shipments_route": [
                393
            ],
            "Undefined_buyer": [
                495
            ],
            "_and": [
                338
            ],
            "_not": [
                338
            ],
            "_or": [
                338
            ],
            "allowed_payment_methods": [
                219
            ],
            "amount_paid": [
                208
            ],
            "assigned_driver_id": [
                506
            ],
            "base_shipping_cost": [
                208
            ],
            "buyer_id": [
                506
            ],
            "cancellation_object": [
                152
            ],
            "company_discount": [
                208
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "delivered_timestamp": [
                490
            ],
            "destination_address_id": [
                506
            ],
            "driver_payout_receipt_out_id": [
                506
            ],
            "driver_route_invoice_in_id": [
                506
            ],
            "dynamic_shipping_cost": [
                208
            ],
            "eta": [
                490
            ],
            "eta_updated": [
                490
            ],
            "external_reference_id": [
                10
            ],
            "id": [
                506
            ],
            "is_active": [
                1
            ],
            "is_company_free_shipping": [
                1
            ],
            "is_seller_free_shipping": [
                1
            ],
            "payment_status": [
                291
            ],
            "preferred_delivery_time_windows_utc": [
                152
            ],
            "products_cost": [
                208
            ],
            "products_cost_seller": [
                208
            ],
            "products_paid_in_advance": [
                1
            ],
            "ready_time": [
                490
            ],
            "required_amount": [
                208
            ],
            "route_id": [
                506
            ],
            "sales_channel_id": [
                506
            ],
            "seller_discount": [
                208
            ],
            "seller_id": [
                506
            ],
            "shipment_number": [
                10
            ],
            "shipping_cost": [
                208
            ],
            "status": [
                327
            ],
            "undefined_buyer_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes": {
            "Shipment": [
                328
            ],
            "Standard_size": [
                265
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "description": [
                9
            ],
            "dimensions_cm": [
                35
            ],
            "id": [
                504
            ],
            "is_deleted": [
                0
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "quantity": [
                207
            ],
            "retail_price": [
                207
            ],
            "shipment_id": [
                504
            ],
            "standard_size_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_aggregate_order_by": {
            "avg": [
                341
            ],
            "count": [
                215
            ],
            "max": [
                343
            ],
            "min": [
                344
            ],
            "stddev": [
                347
            ],
            "stddev_pop": [
                348
            ],
            "stddev_samp": [
                349
            ],
            "sum": [
                352
            ],
            "var_pop": [
                353
            ],
            "var_samp": [
                354
            ],
            "variance": [
                355
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_avg_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_bool_exp": {
            "Shipment": [
                338
            ],
            "Standard_size": [
                268
            ],
            "_and": [
                342
            ],
            "_not": [
                342
            ],
            "_or": [
                342
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "description": [
                10
            ],
            "dimensions_cm": [
                36
            ],
            "id": [
                506
            ],
            "is_deleted": [
                1
            ],
            "name": [
                10
            ],
            "price": [
                208
            ],
            "quantity": [
                208
            ],
            "retail_price": [
                208
            ],
            "shipment_id": [
                506
            ],
            "standard_size_id": [
                506
            ],
            "volume_cm3": [
                208
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_max_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "shipment_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_min_order_by": {
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "shipment_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_order_by": {
            "Shipment": [
                371
            ],
            "Standard_size": [
                271
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "description": [
                215
            ],
            "dimensions_cm": [
                215
            ],
            "id": [
                215
            ],
            "is_deleted": [
                215
            ],
            "name": [
                215
            ],
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "shipment_id": [
                215
            ],
            "standard_size_id": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_select_column": {},
        "shipments_boxes_stddev_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_stddev_pop_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_stddev_samp_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_stream_cursor_input": {
            "initial_value": [
                351
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_stream_cursor_value_input": {
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "description": [
                9
            ],
            "dimensions_cm": [
                35
            ],
            "id": [
                504
            ],
            "is_deleted": [
                0
            ],
            "name": [
                9
            ],
            "price": [
                207
            ],
            "quantity": [
                207
            ],
            "retail_price": [
                207
            ],
            "shipment_id": [
                504
            ],
            "standard_size_id": [
                504
            ],
            "volume_cm3": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_sum_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_var_pop_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_var_samp_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_boxes_variance_order_by": {
            "price": [
                215
            ],
            "quantity": [
                215
            ],
            "retail_price": [
                215
            ],
            "volume_cm3": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_max_fields": {
            "allowed_payment_methods": [
                218
            ],
            "amount_paid": [
                207
            ],
            "assigned_driver_id": [
                504
            ],
            "base_shipping_cost": [
                207
            ],
            "buyer_id": [
                504
            ],
            "company_discount": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "delivered_timestamp": [
                489
            ],
            "destination_address_id": [
                504
            ],
            "driver_payout_receipt_out_id": [
                504
            ],
            "driver_route_invoice_in_id": [
                504
            ],
            "dynamic_shipping_cost": [
                207
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "external_reference_id": [
                9
            ],
            "id": [
                504
            ],
            "payment_status": [
                290
            ],
            "products_cost": [
                207
            ],
            "products_cost_seller": [
                207
            ],
            "ready_time": [
                489
            ],
            "required_amount": [
                207
            ],
            "route_id": [
                504
            ],
            "sales_channel_id": [
                504
            ],
            "seller_discount": [
                207
            ],
            "seller_id": [
                504
            ],
            "shipment_number": [
                9
            ],
            "shipping_cost": [
                207
            ],
            "status": [
                326
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_max_order_by": {
            "allowed_payment_methods": [
                215
            ],
            "amount_paid": [
                215
            ],
            "assigned_driver_id": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "buyer_id": [
                215
            ],
            "company_discount": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "delivered_timestamp": [
                215
            ],
            "destination_address_id": [
                215
            ],
            "driver_payout_receipt_out_id": [
                215
            ],
            "driver_route_invoice_in_id": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "external_reference_id": [
                215
            ],
            "id": [
                215
            ],
            "payment_status": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "ready_time": [
                215
            ],
            "required_amount": [
                215
            ],
            "route_id": [
                215
            ],
            "sales_channel_id": [
                215
            ],
            "seller_discount": [
                215
            ],
            "seller_id": [
                215
            ],
            "shipment_number": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "status": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_min_fields": {
            "allowed_payment_methods": [
                218
            ],
            "amount_paid": [
                207
            ],
            "assigned_driver_id": [
                504
            ],
            "base_shipping_cost": [
                207
            ],
            "buyer_id": [
                504
            ],
            "company_discount": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "delivered_timestamp": [
                489
            ],
            "destination_address_id": [
                504
            ],
            "driver_payout_receipt_out_id": [
                504
            ],
            "driver_route_invoice_in_id": [
                504
            ],
            "dynamic_shipping_cost": [
                207
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "external_reference_id": [
                9
            ],
            "id": [
                504
            ],
            "payment_status": [
                290
            ],
            "products_cost": [
                207
            ],
            "products_cost_seller": [
                207
            ],
            "ready_time": [
                489
            ],
            "required_amount": [
                207
            ],
            "route_id": [
                504
            ],
            "sales_channel_id": [
                504
            ],
            "seller_discount": [
                207
            ],
            "seller_id": [
                504
            ],
            "shipment_number": [
                9
            ],
            "shipping_cost": [
                207
            ],
            "status": [
                326
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_min_order_by": {
            "allowed_payment_methods": [
                215
            ],
            "amount_paid": [
                215
            ],
            "assigned_driver_id": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "buyer_id": [
                215
            ],
            "company_discount": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "delivered_timestamp": [
                215
            ],
            "destination_address_id": [
                215
            ],
            "driver_payout_receipt_out_id": [
                215
            ],
            "driver_route_invoice_in_id": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "external_reference_id": [
                215
            ],
            "id": [
                215
            ],
            "payment_status": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "ready_time": [
                215
            ],
            "required_amount": [
                215
            ],
            "route_id": [
                215
            ],
            "sales_channel_id": [
                215
            ],
            "seller_discount": [
                215
            ],
            "seller_id": [
                215
            ],
            "shipment_number": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "status": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes": {
            "Shipment": [
                328
            ],
            "created_at": [
                489
            ],
            "id": [
                504
            ],
            "note": [
                9
            ],
            "role": [
                502
            ],
            "shipment_id": [
                504
            ],
            "type": [
                288
            ],
            "user_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                364
            ],
            "min": [
                365
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_bool_exp": {
            "Shipment": [
                338
            ],
            "_and": [
                362
            ],
            "_not": [
                362
            ],
            "_or": [
                362
            ],
            "created_at": [
                490
            ],
            "id": [
                506
            ],
            "note": [
                10
            ],
            "role": [
                503
            ],
            "shipment_id": [
                506
            ],
            "type": [
                289
            ],
            "user_id": [
                506
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_insert_input": {
            "note": [
                9
            ],
            "role": [
                502
            ],
            "shipment_id": [
                504
            ],
            "type": [
                288
            ],
            "user_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_max_order_by": {
            "created_at": [
                215
            ],
            "id": [
                215
            ],
            "note": [
                215
            ],
            "role": [
                215
            ],
            "shipment_id": [
                215
            ],
            "type": [
                215
            ],
            "user_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_min_order_by": {
            "created_at": [
                215
            ],
            "id": [
                215
            ],
            "note": [
                215
            ],
            "role": [
                215
            ],
            "shipment_id": [
                215
            ],
            "type": [
                215
            ],
            "user_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                360
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_order_by": {
            "Shipment": [
                371
            ],
            "created_at": [
                215
            ],
            "id": [
                215
            ],
            "note": [
                215
            ],
            "role": [
                215
            ],
            "shipment_id": [
                215
            ],
            "type": [
                215
            ],
            "user_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_select_column": {},
        "shipments_notes_stream_cursor_input": {
            "initial_value": [
                370
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_notes_stream_cursor_value_input": {
            "created_at": [
                489
            ],
            "id": [
                504
            ],
            "note": [
                9
            ],
            "role": [
                502
            ],
            "shipment_id": [
                504
            ],
            "type": [
                288
            ],
            "user_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_order_by": {
            "Assigned_driver": [
                84
            ],
            "Boxes_aggregate": [
                340
            ],
            "Buyer": [
                30
            ],
            "Destination_address": [
                19
            ],
            "Messages_aggregate": [
                158
            ],
            "Notes_aggregate": [
                361
            ],
            "Payments_aggregate": [
                373
            ],
            "Products_aggregate": [
                310
            ],
            "Routes_steps_aggregate": [
                413
            ],
            "Sales_channel": [
                261
            ],
            "Seller": [
                284
            ],
            "Shipments_route": [
                396
            ],
            "Undefined_buyer": [
                498
            ],
            "allowed_payment_methods": [
                215
            ],
            "amount_paid": [
                215
            ],
            "assigned_driver_id": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "buyer_id": [
                215
            ],
            "cancellation_object": [
                215
            ],
            "company_discount": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "delivered_timestamp": [
                215
            ],
            "destination_address_id": [
                215
            ],
            "driver_payout_receipt_out_id": [
                215
            ],
            "driver_route_invoice_in_id": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "external_reference_id": [
                215
            ],
            "id": [
                215
            ],
            "is_active": [
                215
            ],
            "is_company_free_shipping": [
                215
            ],
            "is_seller_free_shipping": [
                215
            ],
            "payment_status": [
                215
            ],
            "preferred_delivery_time_windows_utc": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "products_paid_in_advance": [
                215
            ],
            "ready_time": [
                215
            ],
            "required_amount": [
                215
            ],
            "route_id": [
                215
            ],
            "sales_channel_id": [
                215
            ],
            "seller_discount": [
                215
            ],
            "seller_id": [
                215
            ],
            "shipment_number": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "status": [
                215
            ],
            "undefined_buyer_id": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments": {
            "Shipment": [
                328
            ],
            "amount": [
                207
            ],
            "date_created": [
                489
            ],
            "id": [
                504
            ],
            "method": [
                218
            ],
            "notes": [
                9
            ],
            "payment_gateway": [
                216
            ],
            "payment_reference": [
                9
            ],
            "shipment_id": [
                504
            ],
            "status": [
                221
            ],
            "transaction_type": [
                491
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_aggregate_order_by": {
            "avg": [
                374
            ],
            "count": [
                215
            ],
            "max": [
                376
            ],
            "min": [
                377
            ],
            "stddev": [
                380
            ],
            "stddev_pop": [
                381
            ],
            "stddev_samp": [
                382
            ],
            "sum": [
                385
            ],
            "var_pop": [
                386
            ],
            "var_samp": [
                387
            ],
            "variance": [
                388
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_avg_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_bool_exp": {
            "Shipment": [
                338
            ],
            "_and": [
                375
            ],
            "_not": [
                375
            ],
            "_or": [
                375
            ],
            "amount": [
                208
            ],
            "date_created": [
                490
            ],
            "id": [
                506
            ],
            "method": [
                220
            ],
            "notes": [
                10
            ],
            "payment_gateway": [
                217
            ],
            "payment_reference": [
                10
            ],
            "shipment_id": [
                506
            ],
            "status": [
                222
            ],
            "transaction_type": [
                492
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_max_order_by": {
            "amount": [
                215
            ],
            "date_created": [
                215
            ],
            "id": [
                215
            ],
            "method": [
                215
            ],
            "notes": [
                215
            ],
            "payment_gateway": [
                215
            ],
            "payment_reference": [
                215
            ],
            "shipment_id": [
                215
            ],
            "status": [
                215
            ],
            "transaction_type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_min_order_by": {
            "amount": [
                215
            ],
            "date_created": [
                215
            ],
            "id": [
                215
            ],
            "method": [
                215
            ],
            "notes": [
                215
            ],
            "payment_gateway": [
                215
            ],
            "payment_reference": [
                215
            ],
            "shipment_id": [
                215
            ],
            "status": [
                215
            ],
            "transaction_type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_order_by": {
            "Shipment": [
                371
            ],
            "amount": [
                215
            ],
            "date_created": [
                215
            ],
            "id": [
                215
            ],
            "method": [
                215
            ],
            "notes": [
                215
            ],
            "payment_gateway": [
                215
            ],
            "payment_reference": [
                215
            ],
            "shipment_id": [
                215
            ],
            "status": [
                215
            ],
            "transaction_type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_select_column": {},
        "shipments_payments_stddev_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_stddev_pop_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_stddev_samp_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_stream_cursor_input": {
            "initial_value": [
                384
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_stream_cursor_value_input": {
            "amount": [
                207
            ],
            "date_created": [
                489
            ],
            "id": [
                504
            ],
            "method": [
                218
            ],
            "notes": [
                9
            ],
            "payment_gateway": [
                216
            ],
            "payment_reference": [
                9
            ],
            "shipment_id": [
                504
            ],
            "status": [
                221
            ],
            "transaction_type": [
                491
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_sum_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_var_pop_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_var_samp_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_payments_variance_order_by": {
            "amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes": {
            "Assigned_driver": [
                37
            ],
            "Steps": [
                401,
                {
                    "distinct_on": [
                        410,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        408,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        404
                    ]
                }
            ],
            "assigned_driver_id": [
                504
            ],
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_start_time": [
                489
            ],
            "computed_total_collection_amount": [
                127
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "is_active": [
                0
            ],
            "route_number": [
                6
            ],
            "route_shape_string": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_aggregate": {
            "aggregate": [
                391
            ],
            "nodes": [
                389
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_aggregate_fields": {
            "avg": [
                392
            ],
            "count": [
                6,
                {
                    "columns": [
                        397,
                        "[shipments_routes_select_column!]"
                    ],
                    "distinct": [
                        0
                    ]
                }
            ],
            "max": [
                394
            ],
            "min": [
                395
            ],
            "stddev": [
                398
            ],
            "stddev_pop": [
                399
            ],
            "stddev_samp": [
                400
            ],
            "sum": [
                446
            ],
            "var_pop": [
                447
            ],
            "var_samp": [
                448
            ],
            "variance": [
                449
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_avg_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_bool_exp": {
            "Assigned_driver": [
                39
            ],
            "Steps": [
                404
            ],
            "_and": [
                393
            ],
            "_not": [
                393
            ],
            "_or": [
                393
            ],
            "assigned_driver_id": [
                506
            ],
            "computed_driver_cost": [
                128
            ],
            "computed_shipments_cost": [
                128
            ],
            "computed_start_time": [
                490
            ],
            "computed_total_collection_amount": [
                128
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "id": [
                506
            ],
            "is_active": [
                1
            ],
            "route_number": [
                7
            ],
            "route_shape_string": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_max_fields": {
            "assigned_driver_id": [
                504
            ],
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_start_time": [
                489
            ],
            "computed_total_collection_amount": [
                127
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "route_number": [
                6
            ],
            "route_shape_string": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_min_fields": {
            "assigned_driver_id": [
                504
            ],
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_start_time": [
                489
            ],
            "computed_total_collection_amount": [
                127
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "route_number": [
                6
            ],
            "route_shape_string": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_order_by": {
            "Assigned_driver": [
                84
            ],
            "Steps_aggregate": [
                402
            ],
            "assigned_driver_id": [
                215
            ],
            "computed_driver_cost": [
                215
            ],
            "computed_shipments_cost": [
                215
            ],
            "computed_start_time": [
                215
            ],
            "computed_total_collection_amount": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "id": [
                215
            ],
            "is_active": [
                215
            ],
            "route_number": [
                215
            ],
            "route_shape_string": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_select_column": {},
        "shipments_routes_stddev_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_stddev_pop_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_stddev_samp_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps": {
            "Address": [
                13
            ],
            "Route": [
                389
            ],
            "Shipments": [
                412,
                {
                    "distinct_on": [
                        422,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        420,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        415
                    ]
                }
            ],
            "address_id": [
                504
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "distance_m": [
                207
            ],
            "driver_cost": [
                207
            ],
            "duration_s": [
                207
            ],
            "eta": [
                489
            ],
            "id": [
                504
            ],
            "service": [
                207
            ],
            "shipments_route_id": [
                504
            ],
            "status": [
                257
            ],
            "step_order": [
                207
            ],
            "type": [
                485
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_aggregate_order_by": {
            "avg": [
                403
            ],
            "count": [
                215
            ],
            "max": [
                405
            ],
            "min": [
                406
            ],
            "stddev": [
                434
            ],
            "stddev_pop": [
                435
            ],
            "stddev_samp": [
                436
            ],
            "sum": [
                439
            ],
            "var_pop": [
                441
            ],
            "var_samp": [
                442
            ],
            "variance": [
                443
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_avg_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_bool_exp": {
            "Address": [
                15
            ],
            "Route": [
                393
            ],
            "Shipments": [
                415
            ],
            "_and": [
                404
            ],
            "_not": [
                404
            ],
            "_or": [
                404
            ],
            "address_id": [
                506
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "distance_m": [
                208
            ],
            "driver_cost": [
                208
            ],
            "duration_s": [
                208
            ],
            "eta": [
                490
            ],
            "id": [
                506
            ],
            "service": [
                208
            ],
            "shipments_route_id": [
                506
            ],
            "status": [
                258
            ],
            "step_order": [
                208
            ],
            "type": [
                486
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_max_order_by": {
            "address_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "eta": [
                215
            ],
            "id": [
                215
            ],
            "service": [
                215
            ],
            "shipments_route_id": [
                215
            ],
            "status": [
                215
            ],
            "step_order": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_min_order_by": {
            "address_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "eta": [
                215
            ],
            "id": [
                215
            ],
            "service": [
                215
            ],
            "shipments_route_id": [
                215
            ],
            "status": [
                215
            ],
            "step_order": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                401
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_order_by": {
            "Address": [
                19
            ],
            "Route": [
                396
            ],
            "Shipments_aggregate": [
                413
            ],
            "address_id": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "eta": [
                215
            ],
            "id": [
                215
            ],
            "service": [
                215
            ],
            "shipments_route_id": [
                215
            ],
            "status": [
                215
            ],
            "step_order": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_pk_columns_input": {
            "id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_select_column": {},
        "shipments_routes_steps_set_input": {
            "status": [
                257
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments": {
            "Route_step": [
                401
            ],
            "Shipment": [
                328
            ],
            "collected_amount": [
                207
            ],
            "completion_timestamp": [
                489
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "id": [
                504
            ],
            "is_completed": [
                0
            ],
            "is_noshow": [
                0
            ],
            "shipment_id": [
                504
            ],
            "shipments_routes_step_id": [
                504
            ],
            "type": [
                485
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_aggregate_order_by": {
            "avg": [
                414
            ],
            "count": [
                215
            ],
            "max": [
                417
            ],
            "min": [
                418
            ],
            "stddev": [
                424
            ],
            "stddev_pop": [
                425
            ],
            "stddev_samp": [
                426
            ],
            "sum": [
                429
            ],
            "var_pop": [
                431
            ],
            "var_samp": [
                432
            ],
            "variance": [
                433
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_avg_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_bool_exp": {
            "Route_step": [
                404
            ],
            "Shipment": [
                338
            ],
            "_and": [
                415
            ],
            "_not": [
                415
            ],
            "_or": [
                415
            ],
            "collected_amount": [
                208
            ],
            "completion_timestamp": [
                490
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "eta": [
                490
            ],
            "eta_updated": [
                490
            ],
            "id": [
                506
            ],
            "is_completed": [
                1
            ],
            "is_noshow": [
                1
            ],
            "shipment_id": [
                506
            ],
            "shipments_routes_step_id": [
                506
            ],
            "type": [
                486
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_inc_input": {
            "collected_amount": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_max_order_by": {
            "collected_amount": [
                215
            ],
            "completion_timestamp": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "id": [
                215
            ],
            "shipment_id": [
                215
            ],
            "shipments_routes_step_id": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_min_order_by": {
            "collected_amount": [
                215
            ],
            "completion_timestamp": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "id": [
                215
            ],
            "shipment_id": [
                215
            ],
            "shipments_routes_step_id": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_mutation_response": {
            "affected_rows": [
                6
            ],
            "returning": [
                412
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_order_by": {
            "Route_step": [
                408
            ],
            "Shipment": [
                371
            ],
            "collected_amount": [
                215
            ],
            "completion_timestamp": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "eta": [
                215
            ],
            "eta_updated": [
                215
            ],
            "id": [
                215
            ],
            "is_completed": [
                215
            ],
            "is_noshow": [
                215
            ],
            "shipment_id": [
                215
            ],
            "shipments_routes_step_id": [
                215
            ],
            "type": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_pk_columns_input": {
            "id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_select_column": {},
        "shipments_routes_steps_shipments_set_input": {
            "collected_amount": [
                207
            ],
            "id": [
                504
            ],
            "is_completed": [
                0
            ],
            "shipment_id": [
                504
            ],
            "shipments_routes_step_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_stddev_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_stddev_pop_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_stddev_samp_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_stream_cursor_input": {
            "initial_value": [
                428
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_stream_cursor_value_input": {
            "collected_amount": [
                207
            ],
            "completion_timestamp": [
                489
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "id": [
                504
            ],
            "is_completed": [
                0
            ],
            "is_noshow": [
                0
            ],
            "shipment_id": [
                504
            ],
            "shipments_routes_step_id": [
                504
            ],
            "type": [
                485
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_sum_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_updates": {
            "_inc": [
                416
            ],
            "_set": [
                423
            ],
            "where": [
                415
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_var_pop_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_var_samp_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_shipments_variance_order_by": {
            "collected_amount": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_stddev_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_stddev_pop_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_stddev_samp_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_stream_cursor_input": {
            "initial_value": [
                438
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_stream_cursor_value_input": {
            "address_id": [
                504
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "distance_m": [
                207
            ],
            "driver_cost": [
                207
            ],
            "duration_s": [
                207
            ],
            "eta": [
                489
            ],
            "id": [
                504
            ],
            "service": [
                207
            ],
            "shipments_route_id": [
                504
            ],
            "status": [
                257
            ],
            "step_order": [
                207
            ],
            "type": [
                485
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_sum_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_updates": {
            "_set": [
                411
            ],
            "where": [
                404
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_var_pop_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_var_samp_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_steps_variance_order_by": {
            "distance_m": [
                215
            ],
            "driver_cost": [
                215
            ],
            "duration_s": [
                215
            ],
            "service": [
                215
            ],
            "step_order": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_stream_cursor_input": {
            "initial_value": [
                445
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_stream_cursor_value_input": {
            "assigned_driver_id": [
                504
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "id": [
                504
            ],
            "is_active": [
                0
            ],
            "route_number": [
                6
            ],
            "route_shape_string": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_sum_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                6
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_var_pop_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_var_samp_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_routes_variance_fields": {
            "computed_driver_cost": [
                127
            ],
            "computed_shipments_cost": [
                127
            ],
            "computed_total_collection_amount": [
                127
            ],
            "route_number": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_select_column": {},
        "shipments_select_column_shipments_aggregate_bool_exp_bool_and_arguments_columns": {},
        "shipments_select_column_shipments_aggregate_bool_exp_bool_or_arguments_columns": {},
        "shipments_stddev_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stddev_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stddev_pop_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stddev_pop_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stddev_samp_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stddev_samp_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stream_cursor_input": {
            "initial_value": [
                460
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipments_stream_cursor_value_input": {
            "allowed_payment_methods": [
                218
            ],
            "amount_paid": [
                207
            ],
            "assigned_driver_id": [
                504
            ],
            "base_shipping_cost": [
                207
            ],
            "buyer_id": [
                504
            ],
            "cancellation_object": [
                150
            ],
            "company_discount": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "delivered_timestamp": [
                489
            ],
            "destination_address_id": [
                504
            ],
            "driver_payout_receipt_out_id": [
                504
            ],
            "driver_route_invoice_in_id": [
                504
            ],
            "dynamic_shipping_cost": [
                207
            ],
            "eta": [
                489
            ],
            "eta_updated": [
                489
            ],
            "external_reference_id": [
                9
            ],
            "id": [
                504
            ],
            "is_active": [
                0
            ],
            "is_company_free_shipping": [
                0
            ],
            "is_seller_free_shipping": [
                0
            ],
            "payment_status": [
                290
            ],
            "preferred_delivery_time_windows_utc": [
                150
            ],
            "products_cost": [
                207
            ],
            "products_cost_seller": [
                207
            ],
            "products_paid_in_advance": [
                0
            ],
            "ready_time": [
                489
            ],
            "required_amount": [
                207
            ],
            "route_id": [
                504
            ],
            "sales_channel_id": [
                504
            ],
            "seller_discount": [
                207
            ],
            "seller_id": [
                504
            ],
            "shipment_number": [
                9
            ],
            "shipping_cost": [
                207
            ],
            "status": [
                326
            ],
            "undefined_buyer_id": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "shipments_sum_fields": {
            "amount_paid": [
                207
            ],
            "base_shipping_cost": [
                207
            ],
            "company_discount": [
                207
            ],
            "dynamic_shipping_cost": [
                207
            ],
            "products_cost": [
                207
            ],
            "products_cost_seller": [
                207
            ],
            "required_amount": [
                207
            ],
            "seller_discount": [
                207
            ],
            "shipping_cost": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "shipments_sum_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_var_pop_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_var_pop_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_var_samp_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_var_samp_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipments_variance_fields": {
            "amount_paid": [
                4
            ],
            "base_shipping_cost": [
                4
            ],
            "company_discount": [
                4
            ],
            "dynamic_shipping_cost": [
                4
            ],
            "products_cost": [
                4
            ],
            "products_cost_seller": [
                4
            ],
            "required_amount": [
                4
            ],
            "seller_discount": [
                4
            ],
            "shipping_cost": [
                4
            ],
            "__typename": [
                9
            ]
        },
        "shipments_variance_order_by": {
            "amount_paid": [
                215
            ],
            "base_shipping_cost": [
                215
            ],
            "company_discount": [
                215
            ],
            "dynamic_shipping_cost": [
                215
            ],
            "products_cost": [
                215
            ],
            "products_cost_seller": [
                215
            ],
            "required_amount": [
                215
            ],
            "seller_discount": [
                215
            ],
            "shipping_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipping_city": {},
        "shipping_city_comparison_exp": {
            "_eq": [
                469
            ],
            "_gt": [
                469
            ],
            "_gte": [
                469
            ],
            "_in": [
                469
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                469
            ],
            "_lte": [
                469
            ],
            "_neq": [
                469
            ],
            "_nin": [
                469
            ],
            "__typename": [
                9
            ]
        },
        "shipping_cost_per_city": {
            "Addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "base_cost": [
                207
            ],
            "city": [
                469
            ],
            "cm3_multiplier": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "geo_fence": [
                150,
                {
                    "path": [
                        9
                    ]
                }
            ],
            "id": [
                504
            ],
            "minimum_cost": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "shipping_cost_per_city_bool_exp": {
            "Addresses": [
                15
            ],
            "_and": [
                472
            ],
            "_not": [
                472
            ],
            "_or": [
                472
            ],
            "base_cost": [
                208
            ],
            "city": [
                470
            ],
            "cm3_multiplier": [
                208
            ],
            "date_created": [
                490
            ],
            "date_updated": [
                490
            ],
            "geo_fence": [
                152
            ],
            "id": [
                506
            ],
            "minimum_cost": [
                208
            ],
            "__typename": [
                9
            ]
        },
        "shipping_cost_per_city_order_by": {
            "Addresses_aggregate": [
                14
            ],
            "base_cost": [
                215
            ],
            "city": [
                215
            ],
            "cm3_multiplier": [
                215
            ],
            "date_created": [
                215
            ],
            "date_updated": [
                215
            ],
            "geo_fence": [
                215
            ],
            "id": [
                215
            ],
            "minimum_cost": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "shipping_cost_per_city_select_column": {},
        "shipping_cost_per_city_stream_cursor_input": {
            "initial_value": [
                476
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "shipping_cost_per_city_stream_cursor_value_input": {
            "base_cost": [
                207
            ],
            "city": [
                469
            ],
            "cm3_multiplier": [
                207
            ],
            "date_created": [
                489
            ],
            "date_updated": [
                489
            ],
            "geo_fence": [
                150
            ],
            "id": [
                504
            ],
            "minimum_cost": [
                207
            ],
            "__typename": [
                9
            ]
        },
        "skills": {
            "Drivers": [
                107,
                {
                    "distinct_on": [
                        113,
                        "[drivers_skills_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        112,
                        "[drivers_skills_order_by!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "skills_bool_exp": {
            "Drivers": [
                109
            ],
            "_and": [
                478
            ],
            "_not": [
                478
            ],
            "_or": [
                478
            ],
            "id": [
                506
            ],
            "name": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "skills_order_by": {
            "Drivers_aggregate": [
                108
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "skills_select_column": {},
        "skills_stream_cursor_input": {
            "initial_value": [
                482
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "skills_stream_cursor_value_input": {
            "id": [
                504
            ],
            "name": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "st_d_within_geography_input": {
            "distance": [
                4
            ],
            "from": [
                144
            ],
            "use_spheroid": [
                0
            ],
            "__typename": [
                9
            ]
        },
        "st_d_within_input": {
            "distance": [
                4
            ],
            "from": [
                147
            ],
            "__typename": [
                9
            ]
        },
        "step_type": {},
        "step_type_comparison_exp": {
            "_eq": [
                485
            ],
            "_gt": [
                485
            ],
            "_gte": [
                485
            ],
            "_in": [
                485
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                485
            ],
            "_lte": [
                485
            ],
            "_neq": [
                485
            ],
            "_nin": [
                485
            ],
            "__typename": [
                9
            ]
        },
        "timestamp": {},
        "timestamp_comparison_exp": {
            "_eq": [
                487
            ],
            "_gt": [
                487
            ],
            "_gte": [
                487
            ],
            "_in": [
                487
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                487
            ],
            "_lte": [
                487
            ],
            "_neq": [
                487
            ],
            "_nin": [
                487
            ],
            "__typename": [
                9
            ]
        },
        "timestamptz": {},
        "timestamptz_comparison_exp": {
            "_eq": [
                489
            ],
            "_gt": [
                489
            ],
            "_gte": [
                489
            ],
            "_in": [
                489
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                489
            ],
            "_lte": [
                489
            ],
            "_neq": [
                489
            ],
            "_nin": [
                489
            ],
            "__typename": [
                9
            ]
        },
        "transaction_type": {},
        "transaction_type_comparison_exp": {
            "_eq": [
                491
            ],
            "_gt": [
                491
            ],
            "_gte": [
                491
            ],
            "_in": [
                491
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                491
            ],
            "_lte": [
                491
            ],
            "_neq": [
                491
            ],
            "_nin": [
                491
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers": {
            "Addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "Shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "Shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_aggregate_order_by": {
            "count": [
                215
            ],
            "max": [
                496
            ],
            "min": [
                497
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_bool_exp": {
            "Addresses": [
                15
            ],
            "Shipments": [
                338
            ],
            "Shipments_aggregate": [
                330
            ],
            "_and": [
                495
            ],
            "_not": [
                495
            ],
            "_or": [
                495
            ],
            "has_whatsapp": [
                1
            ],
            "id": [
                506
            ],
            "name": [
                10
            ],
            "phone_number": [
                10
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_max_order_by": {
            "id": [
                215
            ],
            "name": [
                215
            ],
            "phone_number": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_min_order_by": {
            "id": [
                215
            ],
            "name": [
                215
            ],
            "phone_number": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_order_by": {
            "Addresses_aggregate": [
                14
            ],
            "Shipments_aggregate": [
                335
            ],
            "has_whatsapp": [
                215
            ],
            "id": [
                215
            ],
            "name": [
                215
            ],
            "phone_number": [
                215
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_select_column": {},
        "undefined_buyers_stream_cursor_input": {
            "initial_value": [
                501
            ],
            "ordering": [
                34
            ],
            "__typename": [
                9
            ]
        },
        "undefined_buyers_stream_cursor_value_input": {
            "has_whatsapp": [
                0
            ],
            "id": [
                504
            ],
            "name": [
                9
            ],
            "phone_number": [
                9
            ],
            "__typename": [
                9
            ]
        },
        "user_role": {},
        "user_role_comparison_exp": {
            "_eq": [
                502
            ],
            "_gt": [
                502
            ],
            "_gte": [
                502
            ],
            "_in": [
                502
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                502
            ],
            "_lte": [
                502
            ],
            "_neq": [
                502
            ],
            "_nin": [
                502
            ],
            "__typename": [
                9
            ]
        },
        "uuid": {},
        "uuid_array_comparison_exp": {
            "_contained_in": [
                504
            ],
            "_contains": [
                504
            ],
            "_eq": [
                504
            ],
            "_gt": [
                504
            ],
            "_gte": [
                504
            ],
            "_in": [
                504
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                504
            ],
            "_lte": [
                504
            ],
            "_neq": [
                504
            ],
            "_nin": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "uuid_comparison_exp": {
            "_eq": [
                504
            ],
            "_gt": [
                504
            ],
            "_gte": [
                504
            ],
            "_in": [
                504
            ],
            "_is_null": [
                0
            ],
            "_lt": [
                504
            ],
            "_lte": [
                504
            ],
            "_neq": [
                504
            ],
            "_nin": [
                504
            ],
            "__typename": [
                9
            ]
        },
        "Query": {
            "addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "addresses_by_pk": [
                13,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "buyers": [
                28,
                {
                    "distinct_on": [
                        31,
                        "[buyers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        30,
                        "[buyers_order_by!]"
                    ],
                    "where": [
                        29
                    ]
                }
            ],
            "buyers_by_pk": [
                28,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers": [
                37,
                {
                    "distinct_on": [
                        105,
                        "[drivers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        84,
                        "[drivers_order_by!]"
                    ],
                    "where": [
                        39
                    ]
                }
            ],
            "drivers_by_pk": [
                37,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_collection_invoices_in": [
                40,
                {
                    "distinct_on": [
                        48,
                        "[drivers_collection_invoices_in_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        47,
                        "[drivers_collection_invoices_in_order_by!]"
                    ],
                    "where": [
                        44
                    ]
                }
            ],
            "drivers_collection_invoices_in_aggregate": [
                41,
                {
                    "distinct_on": [
                        48,
                        "[drivers_collection_invoices_in_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        47,
                        "[drivers_collection_invoices_in_order_by!]"
                    ],
                    "where": [
                        44
                    ]
                }
            ],
            "drivers_collection_invoices_in_by_pk": [
                40,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_locations": [
                61,
                {
                    "distinct_on": [
                        72,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        71,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        64
                    ]
                }
            ],
            "drivers_locations_by_pk": [
                61,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_payouts_receipts_out": [
                85,
                {
                    "distinct_on": [
                        93,
                        "[drivers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        92,
                        "[drivers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "drivers_payouts_receipts_out_aggregate": [
                86,
                {
                    "distinct_on": [
                        93,
                        "[drivers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        92,
                        "[drivers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "drivers_payouts_receipts_out_by_pk": [
                85,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_skills": [
                107,
                {
                    "distinct_on": [
                        113,
                        "[drivers_skills_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        112,
                        "[drivers_skills_order_by!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "drivers_skills_by_pk": [
                107,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "env_variables": [
                121,
                {
                    "distinct_on": [
                        124,
                        "[env_variables_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        123,
                        "[env_variables_order_by!]"
                    ],
                    "where": [
                        122
                    ]
                }
            ],
            "env_variables_by_pk": [
                121,
                {
                    "key": [
                        9,
                        "String!"
                    ]
                }
            ],
            "food_categories": [
                129,
                {
                    "distinct_on": [
                        141,
                        "[food_categories_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        131,
                        "[food_categories_order_by!]"
                    ],
                    "where": [
                        130
                    ]
                }
            ],
            "food_categories_by_pk": [
                129,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products": [
                132,
                {
                    "distinct_on": [
                        138,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        137,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        134
                    ]
                }
            ],
            "food_categories_products_by_pk": [
                132,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages": [
                153,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "messages_aggregate": [
                154,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "messages_by_pk": [
                153,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages_from": [
                161,
                {
                    "distinct_on": [
                        172,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        171,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        163
                    ]
                }
            ],
            "messages_from_by_pk": [
                161,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages_to": [
                190,
                {
                    "distinct_on": [
                        201,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        200,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        192
                    ]
                }
            ],
            "messages_to_by_pk": [
                190,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "operators": [
                209,
                {
                    "distinct_on": [
                        212,
                        "[operators_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        211,
                        "[operators_order_by!]"
                    ],
                    "where": [
                        210
                    ]
                }
            ],
            "operators_by_pk": [
                209,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "products": [
                223,
                {
                    "distinct_on": [
                        247,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        246,
                        "[products_order_by!]"
                    ],
                    "where": [
                        226
                    ]
                }
            ],
            "products_by_pk": [
                223,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "products_extras": [
                227,
                {
                    "distinct_on": [
                        234,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        233,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "products_extras_by_pk": [
                227,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "sales_channels": [
                259,
                {
                    "distinct_on": [
                        262,
                        "[sales_channels_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        261,
                        "[sales_channels_order_by!]"
                    ],
                    "where": [
                        260
                    ]
                }
            ],
            "sales_channels_by_pk": [
                259,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "seller_products_standard_sizes": [
                265,
                {
                    "distinct_on": [
                        272,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        271,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        268
                    ]
                }
            ],
            "seller_products_standard_sizes_by_pk": [
                265,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "sellers": [
                282,
                {
                    "distinct_on": [
                        285,
                        "[sellers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        284,
                        "[sellers_order_by!]"
                    ],
                    "where": [
                        283
                    ]
                }
            ],
            "sellers_by_pk": [
                282,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipment_product_item_extras": [
                292,
                {
                    "distinct_on": [
                        299,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        298,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        295
                    ]
                }
            ],
            "shipment_product_item_extras_by_pk": [
                292,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipment_products_items": [
                309,
                {
                    "distinct_on": [
                        316,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        315,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        312
                    ]
                }
            ],
            "shipment_products_items_by_pk": [
                309,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "shipments_boxes": [
                339,
                {
                    "distinct_on": [
                        346,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        345,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        342
                    ]
                }
            ],
            "shipments_boxes_by_pk": [
                339,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_by_pk": [
                328,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_notes": [
                360,
                {
                    "distinct_on": [
                        368,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        367,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        362
                    ]
                }
            ],
            "shipments_payments": [
                372,
                {
                    "distinct_on": [
                        379,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        378,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        375
                    ]
                }
            ],
            "shipments_payments_by_pk": [
                372,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes": [
                389,
                {
                    "distinct_on": [
                        397,
                        "[shipments_routes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        396,
                        "[shipments_routes_order_by!]"
                    ],
                    "where": [
                        393
                    ]
                }
            ],
            "shipments_routes_aggregate": [
                390,
                {
                    "distinct_on": [
                        397,
                        "[shipments_routes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        396,
                        "[shipments_routes_order_by!]"
                    ],
                    "where": [
                        393
                    ]
                }
            ],
            "shipments_routes_by_pk": [
                389,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps": [
                401,
                {
                    "distinct_on": [
                        410,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        408,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        404
                    ]
                }
            ],
            "shipments_routes_steps_by_pk": [
                401,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments": [
                412,
                {
                    "distinct_on": [
                        422,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        420,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        415
                    ]
                }
            ],
            "shipments_routes_steps_shipments_by_pk": [
                412,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipping_cost_per_city": [
                471,
                {
                    "distinct_on": [
                        474,
                        "[shipping_cost_per_city_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        473,
                        "[shipping_cost_per_city_order_by!]"
                    ],
                    "where": [
                        472
                    ]
                }
            ],
            "shipping_cost_per_city_by_pk": [
                471,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "skills": [
                477,
                {
                    "distinct_on": [
                        480,
                        "[skills_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        479,
                        "[skills_order_by!]"
                    ],
                    "where": [
                        478
                    ]
                }
            ],
            "skills_by_pk": [
                477,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "undefined_buyers": [
                493,
                {
                    "distinct_on": [
                        499,
                        "[undefined_buyers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        498,
                        "[undefined_buyers_order_by!]"
                    ],
                    "where": [
                        495
                    ]
                }
            ],
            "undefined_buyers_by_pk": [
                493,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "__typename": [
                9
            ]
        },
        "Mutation": {
            "driver_update_destination_address": [
                2,
                {
                    "destination_address_id": [
                        9,
                        "String!"
                    ],
                    "route_id": [
                        9,
                        "String!"
                    ],
                    "shipment_id": [
                        9,
                        "String!"
                    ],
                    "updated_location": [
                        147,
                        "geometry!"
                    ]
                }
            ],
            "extract_coordinates_from_url": [
                5,
                {
                    "url": [
                        9,
                        "String!"
                    ]
                }
            ],
            "finish_scheduled_route": [
                3,
                {
                    "route_id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "insert_drivers_locations": [
                69,
                {
                    "objects": [
                        66,
                        "[drivers_locations_insert_input!]!"
                    ],
                    "on_conflict": [
                        70
                    ]
                }
            ],
            "insert_drivers_locations_one": [
                61,
                {
                    "object": [
                        66,
                        "drivers_locations_insert_input!"
                    ],
                    "on_conflict": [
                        70
                    ]
                }
            ],
            "insert_messages": [
                181,
                {
                    "objects": [
                        176,
                        "[messages_insert_input!]!"
                    ],
                    "on_conflict": [
                        183
                    ]
                }
            ],
            "insert_messages_from": [
                168,
                {
                    "objects": [
                        165,
                        "[messages_from_insert_input!]!"
                    ],
                    "on_conflict": [
                        170
                    ]
                }
            ],
            "insert_messages_from_one": [
                161,
                {
                    "object": [
                        165,
                        "messages_from_insert_input!"
                    ],
                    "on_conflict": [
                        170
                    ]
                }
            ],
            "insert_messages_one": [
                153,
                {
                    "object": [
                        176,
                        "messages_insert_input!"
                    ],
                    "on_conflict": [
                        183
                    ]
                }
            ],
            "insert_messages_to": [
                197,
                {
                    "objects": [
                        194,
                        "[messages_to_insert_input!]!"
                    ],
                    "on_conflict": [
                        199
                    ]
                }
            ],
            "insert_messages_to_one": [
                190,
                {
                    "object": [
                        194,
                        "messages_to_insert_input!"
                    ],
                    "on_conflict": [
                        199
                    ]
                }
            ],
            "insert_shipments_notes": [
                366,
                {
                    "objects": [
                        363,
                        "[shipments_notes_insert_input!]!"
                    ]
                }
            ],
            "insert_shipments_notes_one": [
                360,
                {
                    "object": [
                        363,
                        "shipments_notes_insert_input!"
                    ]
                }
            ],
            "request_shipment_status_change": [
                5,
                {
                    "payload": [
                        150,
                        "jsonb!"
                    ],
                    "return_fields": [
                        150
                    ],
                    "shipment_id": [
                        9,
                        "String!"
                    ]
                }
            ],
            "send_shipment_invoice_on_whatsapp": [
                8,
                {
                    "shipment_id": [
                        9,
                        "String!"
                    ]
                }
            ],
            "update_addresses": [
                18,
                {
                    "_set": [
                        22
                    ],
                    "where": [
                        15,
                        "addresses_bool_exp!"
                    ]
                }
            ],
            "update_addresses_by_pk": [
                13,
                {
                    "_set": [
                        22
                    ],
                    "pk_columns": [
                        20,
                        "addresses_pk_columns_input!"
                    ]
                }
            ],
            "update_addresses_many": [
                18,
                {
                    "updates": [
                        25,
                        "[addresses_updates!]!"
                    ]
                }
            ],
            "update_drivers": [
                83,
                {
                    "_append": [
                        38
                    ],
                    "_delete_at_path": [
                        58
                    ],
                    "_delete_elem": [
                        59
                    ],
                    "_delete_key": [
                        60
                    ],
                    "_prepend": [
                        104
                    ],
                    "_set": [
                        106
                    ],
                    "where": [
                        39,
                        "drivers_bool_exp!"
                    ]
                }
            ],
            "update_drivers_by_pk": [
                37,
                {
                    "_append": [
                        38
                    ],
                    "_delete_at_path": [
                        58
                    ],
                    "_delete_elem": [
                        59
                    ],
                    "_delete_key": [
                        60
                    ],
                    "_prepend": [
                        104
                    ],
                    "_set": [
                        106
                    ],
                    "pk_columns": [
                        103,
                        "drivers_pk_columns_input!"
                    ]
                }
            ],
            "update_drivers_many": [
                83,
                {
                    "updates": [
                        118,
                        "[drivers_updates!]!"
                    ]
                }
            ],
            "update_messages": [
                181,
                {
                    "_set": [
                        187
                    ],
                    "where": [
                        159,
                        "messages_bool_exp!"
                    ]
                }
            ],
            "update_messages_by_pk": [
                153,
                {
                    "_set": [
                        187
                    ],
                    "pk_columns": [
                        185,
                        "messages_pk_columns_input!"
                    ]
                }
            ],
            "update_messages_many": [
                181,
                {
                    "updates": [
                        206,
                        "[messages_updates!]!"
                    ]
                }
            ],
            "update_shipments_routes_steps": [
                407,
                {
                    "_set": [
                        411
                    ],
                    "where": [
                        404,
                        "shipments_routes_steps_bool_exp!"
                    ]
                }
            ],
            "update_shipments_routes_steps_by_pk": [
                401,
                {
                    "_set": [
                        411
                    ],
                    "pk_columns": [
                        409,
                        "shipments_routes_steps_pk_columns_input!"
                    ]
                }
            ],
            "update_shipments_routes_steps_many": [
                407,
                {
                    "updates": [
                        440,
                        "[shipments_routes_steps_updates!]!"
                    ]
                }
            ],
            "update_shipments_routes_steps_shipments": [
                419,
                {
                    "_inc": [
                        416
                    ],
                    "_set": [
                        423
                    ],
                    "where": [
                        415,
                        "shipments_routes_steps_shipments_bool_exp!"
                    ]
                }
            ],
            "update_shipments_routes_steps_shipments_by_pk": [
                412,
                {
                    "_inc": [
                        416
                    ],
                    "_set": [
                        423
                    ],
                    "pk_columns": [
                        421,
                        "shipments_routes_steps_shipments_pk_columns_input!"
                    ]
                }
            ],
            "update_shipments_routes_steps_shipments_many": [
                419,
                {
                    "updates": [
                        430,
                        "[shipments_routes_steps_shipments_updates!]!"
                    ]
                }
            ],
            "update_user_password": [
                5,
                {
                    "old_password": [
                        9,
                        "String!"
                    ],
                    "updated_password": [
                        9,
                        "String!"
                    ]
                }
            ],
            "__typename": [
                9
            ]
        },
        "Subscription": {
            "addresses": [
                13,
                {
                    "distinct_on": [
                        21,
                        "[addresses_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        19,
                        "[addresses_order_by!]"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "addresses_by_pk": [
                13,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "addresses_stream": [
                13,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        23,
                        "[addresses_stream_cursor_input]!"
                    ],
                    "where": [
                        15
                    ]
                }
            ],
            "buyers": [
                28,
                {
                    "distinct_on": [
                        31,
                        "[buyers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        30,
                        "[buyers_order_by!]"
                    ],
                    "where": [
                        29
                    ]
                }
            ],
            "buyers_by_pk": [
                28,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "buyers_stream": [
                28,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        32,
                        "[buyers_stream_cursor_input]!"
                    ],
                    "where": [
                        29
                    ]
                }
            ],
            "drivers": [
                37,
                {
                    "distinct_on": [
                        105,
                        "[drivers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        84,
                        "[drivers_order_by!]"
                    ],
                    "where": [
                        39
                    ]
                }
            ],
            "drivers_by_pk": [
                37,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_collection_invoices_in": [
                40,
                {
                    "distinct_on": [
                        48,
                        "[drivers_collection_invoices_in_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        47,
                        "[drivers_collection_invoices_in_order_by!]"
                    ],
                    "where": [
                        44
                    ]
                }
            ],
            "drivers_collection_invoices_in_aggregate": [
                41,
                {
                    "distinct_on": [
                        48,
                        "[drivers_collection_invoices_in_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        47,
                        "[drivers_collection_invoices_in_order_by!]"
                    ],
                    "where": [
                        44
                    ]
                }
            ],
            "drivers_collection_invoices_in_by_pk": [
                40,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_collection_invoices_in_stream": [
                40,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        52,
                        "[drivers_collection_invoices_in_stream_cursor_input]!"
                    ],
                    "where": [
                        44
                    ]
                }
            ],
            "drivers_locations": [
                61,
                {
                    "distinct_on": [
                        72,
                        "[drivers_locations_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        71,
                        "[drivers_locations_order_by!]"
                    ],
                    "where": [
                        64
                    ]
                }
            ],
            "drivers_locations_by_pk": [
                61,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_locations_stream": [
                61,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        76,
                        "[drivers_locations_stream_cursor_input]!"
                    ],
                    "where": [
                        64
                    ]
                }
            ],
            "drivers_payouts_receipts_out": [
                85,
                {
                    "distinct_on": [
                        93,
                        "[drivers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        92,
                        "[drivers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "drivers_payouts_receipts_out_aggregate": [
                86,
                {
                    "distinct_on": [
                        93,
                        "[drivers_payouts_receipts_out_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        92,
                        "[drivers_payouts_receipts_out_order_by!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "drivers_payouts_receipts_out_by_pk": [
                85,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_payouts_receipts_out_stream": [
                85,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        97,
                        "[drivers_payouts_receipts_out_stream_cursor_input]!"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "drivers_skills": [
                107,
                {
                    "distinct_on": [
                        113,
                        "[drivers_skills_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        112,
                        "[drivers_skills_order_by!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "drivers_skills_by_pk": [
                107,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "drivers_skills_stream": [
                107,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        114,
                        "[drivers_skills_stream_cursor_input]!"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "drivers_stream": [
                37,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        116,
                        "[drivers_stream_cursor_input]!"
                    ],
                    "where": [
                        39
                    ]
                }
            ],
            "env_variables": [
                121,
                {
                    "distinct_on": [
                        124,
                        "[env_variables_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        123,
                        "[env_variables_order_by!]"
                    ],
                    "where": [
                        122
                    ]
                }
            ],
            "env_variables_by_pk": [
                121,
                {
                    "key": [
                        9,
                        "String!"
                    ]
                }
            ],
            "env_variables_stream": [
                121,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        125,
                        "[env_variables_stream_cursor_input]!"
                    ],
                    "where": [
                        122
                    ]
                }
            ],
            "food_categories": [
                129,
                {
                    "distinct_on": [
                        141,
                        "[food_categories_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        131,
                        "[food_categories_order_by!]"
                    ],
                    "where": [
                        130
                    ]
                }
            ],
            "food_categories_by_pk": [
                129,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products": [
                132,
                {
                    "distinct_on": [
                        138,
                        "[food_categories_products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        137,
                        "[food_categories_products_order_by!]"
                    ],
                    "where": [
                        134
                    ]
                }
            ],
            "food_categories_products_by_pk": [
                132,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "food_categories_products_stream": [
                132,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        139,
                        "[food_categories_products_stream_cursor_input]!"
                    ],
                    "where": [
                        134
                    ]
                }
            ],
            "food_categories_stream": [
                129,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        142,
                        "[food_categories_stream_cursor_input]!"
                    ],
                    "where": [
                        130
                    ]
                }
            ],
            "messages": [
                153,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "messages_aggregate": [
                154,
                {
                    "distinct_on": [
                        186,
                        "[messages_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        184,
                        "[messages_order_by!]"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "messages_by_pk": [
                153,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages_from": [
                161,
                {
                    "distinct_on": [
                        172,
                        "[messages_from_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        171,
                        "[messages_from_order_by!]"
                    ],
                    "where": [
                        163
                    ]
                }
            ],
            "messages_from_by_pk": [
                161,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages_from_stream": [
                161,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        173,
                        "[messages_from_stream_cursor_input]!"
                    ],
                    "where": [
                        163
                    ]
                }
            ],
            "messages_stream": [
                153,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        188,
                        "[messages_stream_cursor_input]!"
                    ],
                    "where": [
                        159
                    ]
                }
            ],
            "messages_to": [
                190,
                {
                    "distinct_on": [
                        201,
                        "[messages_to_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        200,
                        "[messages_to_order_by!]"
                    ],
                    "where": [
                        192
                    ]
                }
            ],
            "messages_to_by_pk": [
                190,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "messages_to_stream": [
                190,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        202,
                        "[messages_to_stream_cursor_input]!"
                    ],
                    "where": [
                        192
                    ]
                }
            ],
            "operators": [
                209,
                {
                    "distinct_on": [
                        212,
                        "[operators_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        211,
                        "[operators_order_by!]"
                    ],
                    "where": [
                        210
                    ]
                }
            ],
            "operators_by_pk": [
                209,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "operators_stream": [
                209,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        213,
                        "[operators_stream_cursor_input]!"
                    ],
                    "where": [
                        210
                    ]
                }
            ],
            "products": [
                223,
                {
                    "distinct_on": [
                        247,
                        "[products_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        246,
                        "[products_order_by!]"
                    ],
                    "where": [
                        226
                    ]
                }
            ],
            "products_by_pk": [
                223,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "products_extras": [
                227,
                {
                    "distinct_on": [
                        234,
                        "[products_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        233,
                        "[products_extras_order_by!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "products_extras_by_pk": [
                227,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "products_extras_stream": [
                227,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        238,
                        "[products_extras_stream_cursor_input]!"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "products_stream": [
                223,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        251,
                        "[products_stream_cursor_input]!"
                    ],
                    "where": [
                        226
                    ]
                }
            ],
            "sales_channels": [
                259,
                {
                    "distinct_on": [
                        262,
                        "[sales_channels_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        261,
                        "[sales_channels_order_by!]"
                    ],
                    "where": [
                        260
                    ]
                }
            ],
            "sales_channels_by_pk": [
                259,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "sales_channels_stream": [
                259,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        263,
                        "[sales_channels_stream_cursor_input]!"
                    ],
                    "where": [
                        260
                    ]
                }
            ],
            "seller_products_standard_sizes": [
                265,
                {
                    "distinct_on": [
                        272,
                        "[seller_products_standard_sizes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        271,
                        "[seller_products_standard_sizes_order_by!]"
                    ],
                    "where": [
                        268
                    ]
                }
            ],
            "seller_products_standard_sizes_by_pk": [
                265,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "seller_products_standard_sizes_stream": [
                265,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        276,
                        "[seller_products_standard_sizes_stream_cursor_input]!"
                    ],
                    "where": [
                        268
                    ]
                }
            ],
            "sellers": [
                282,
                {
                    "distinct_on": [
                        285,
                        "[sellers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        284,
                        "[sellers_order_by!]"
                    ],
                    "where": [
                        283
                    ]
                }
            ],
            "sellers_by_pk": [
                282,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "sellers_stream": [
                282,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        286,
                        "[sellers_stream_cursor_input]!"
                    ],
                    "where": [
                        283
                    ]
                }
            ],
            "shipment_product_item_extras": [
                292,
                {
                    "distinct_on": [
                        299,
                        "[shipment_product_item_extras_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        298,
                        "[shipment_product_item_extras_order_by!]"
                    ],
                    "where": [
                        295
                    ]
                }
            ],
            "shipment_product_item_extras_by_pk": [
                292,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipment_product_item_extras_stream": [
                292,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        303,
                        "[shipment_product_item_extras_stream_cursor_input]!"
                    ],
                    "where": [
                        295
                    ]
                }
            ],
            "shipment_products_items": [
                309,
                {
                    "distinct_on": [
                        316,
                        "[shipment_products_items_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        315,
                        "[shipment_products_items_order_by!]"
                    ],
                    "where": [
                        312
                    ]
                }
            ],
            "shipment_products_items_by_pk": [
                309,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipment_products_items_stream": [
                309,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        320,
                        "[shipment_products_items_stream_cursor_input]!"
                    ],
                    "where": [
                        312
                    ]
                }
            ],
            "shipments": [
                328,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "shipments_aggregate": [
                329,
                {
                    "distinct_on": [
                        450,
                        "[shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        371,
                        "[shipments_order_by!]"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "shipments_boxes": [
                339,
                {
                    "distinct_on": [
                        346,
                        "[shipments_boxes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        345,
                        "[shipments_boxes_order_by!]"
                    ],
                    "where": [
                        342
                    ]
                }
            ],
            "shipments_boxes_by_pk": [
                339,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_boxes_stream": [
                339,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        350,
                        "[shipments_boxes_stream_cursor_input]!"
                    ],
                    "where": [
                        342
                    ]
                }
            ],
            "shipments_by_pk": [
                328,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_notes": [
                360,
                {
                    "distinct_on": [
                        368,
                        "[shipments_notes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        367,
                        "[shipments_notes_order_by!]"
                    ],
                    "where": [
                        362
                    ]
                }
            ],
            "shipments_notes_stream": [
                360,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        369,
                        "[shipments_notes_stream_cursor_input]!"
                    ],
                    "where": [
                        362
                    ]
                }
            ],
            "shipments_payments": [
                372,
                {
                    "distinct_on": [
                        379,
                        "[shipments_payments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        378,
                        "[shipments_payments_order_by!]"
                    ],
                    "where": [
                        375
                    ]
                }
            ],
            "shipments_payments_by_pk": [
                372,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_payments_stream": [
                372,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        383,
                        "[shipments_payments_stream_cursor_input]!"
                    ],
                    "where": [
                        375
                    ]
                }
            ],
            "shipments_routes": [
                389,
                {
                    "distinct_on": [
                        397,
                        "[shipments_routes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        396,
                        "[shipments_routes_order_by!]"
                    ],
                    "where": [
                        393
                    ]
                }
            ],
            "shipments_routes_aggregate": [
                390,
                {
                    "distinct_on": [
                        397,
                        "[shipments_routes_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        396,
                        "[shipments_routes_order_by!]"
                    ],
                    "where": [
                        393
                    ]
                }
            ],
            "shipments_routes_by_pk": [
                389,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps": [
                401,
                {
                    "distinct_on": [
                        410,
                        "[shipments_routes_steps_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        408,
                        "[shipments_routes_steps_order_by!]"
                    ],
                    "where": [
                        404
                    ]
                }
            ],
            "shipments_routes_steps_by_pk": [
                401,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments": [
                412,
                {
                    "distinct_on": [
                        422,
                        "[shipments_routes_steps_shipments_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        420,
                        "[shipments_routes_steps_shipments_order_by!]"
                    ],
                    "where": [
                        415
                    ]
                }
            ],
            "shipments_routes_steps_shipments_by_pk": [
                412,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipments_routes_steps_shipments_stream": [
                412,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        427,
                        "[shipments_routes_steps_shipments_stream_cursor_input]!"
                    ],
                    "where": [
                        415
                    ]
                }
            ],
            "shipments_routes_steps_stream": [
                401,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        437,
                        "[shipments_routes_steps_stream_cursor_input]!"
                    ],
                    "where": [
                        404
                    ]
                }
            ],
            "shipments_routes_stream": [
                389,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        444,
                        "[shipments_routes_stream_cursor_input]!"
                    ],
                    "where": [
                        393
                    ]
                }
            ],
            "shipments_stream": [
                328,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        459,
                        "[shipments_stream_cursor_input]!"
                    ],
                    "where": [
                        338
                    ]
                }
            ],
            "shipping_cost_per_city": [
                471,
                {
                    "distinct_on": [
                        474,
                        "[shipping_cost_per_city_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        473,
                        "[shipping_cost_per_city_order_by!]"
                    ],
                    "where": [
                        472
                    ]
                }
            ],
            "shipping_cost_per_city_by_pk": [
                471,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "shipping_cost_per_city_stream": [
                471,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        475,
                        "[shipping_cost_per_city_stream_cursor_input]!"
                    ],
                    "where": [
                        472
                    ]
                }
            ],
            "skills": [
                477,
                {
                    "distinct_on": [
                        480,
                        "[skills_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        479,
                        "[skills_order_by!]"
                    ],
                    "where": [
                        478
                    ]
                }
            ],
            "skills_by_pk": [
                477,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "skills_stream": [
                477,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        481,
                        "[skills_stream_cursor_input]!"
                    ],
                    "where": [
                        478
                    ]
                }
            ],
            "undefined_buyers": [
                493,
                {
                    "distinct_on": [
                        499,
                        "[undefined_buyers_select_column!]"
                    ],
                    "limit": [
                        6
                    ],
                    "offset": [
                        6
                    ],
                    "order_by": [
                        498,
                        "[undefined_buyers_order_by!]"
                    ],
                    "where": [
                        495
                    ]
                }
            ],
            "undefined_buyers_by_pk": [
                493,
                {
                    "id": [
                        504,
                        "uuid!"
                    ]
                }
            ],
            "undefined_buyers_stream": [
                493,
                {
                    "batch_size": [
                        6,
                        "Int!"
                    ],
                    "cursor": [
                        500,
                        "[undefined_buyers_stream_cursor_input]!"
                    ],
                    "where": [
                        495
                    ]
                }
            ],
            "__typename": [
                9
            ]
        }
    }
}